export const t = {
  appName: 'webUI',
  common: {
    loading: 'Cargando…',
    error: 'Error',
    close: 'Cerrar',
    results: 'resultados',
    lines: 'líneas',
    accounts: 'cuentas',
    units: 'unidades',
  },
  progress: {
    almostDone: 'Casi listo…',    // shown when a request overruns its ETA
    running: 'Ejecutando…',       // Reports run in progress
    etaSuffix: 'restante',        // "≈ 8 s restante"
  },
  theme: {
    label: 'Tema',
    light: 'Claro',
    dark: 'Oscuro',
    system: 'Sistema',
  },
  service: {
    title: 'Taller de servicio',
    subtitle: 'Órdenes de trabajo del taller, desglosadas por trabajo. Mide la productividad de los técnicos (horas reales vs. estimadas), los ingresos por mano de obra y el avance de las órdenes abiertas.',
    filters: { tech: 'Técnico', status: 'Estado', allTechs: 'Todos los técnicos' },
    statusAll: 'Todas',
    statusOpen: 'Abiertas',
    statusComplete: 'Completadas',
    kpi: {
      revenue: 'Ingreso mano de obra',
      orders: 'Órdenes',
      jobs: 'Trabajos',
      hours: 'Horas reales',
      perHour: 'Ingreso / hora',
    },
    techTitle: 'Productividad por técnico',
    techCols: {
      tech: 'Técnico',
      jobs: 'Trabajos',
      estHrs: 'Hrs est.',
      actHrs: 'Hrs reales',
      eff: 'Eficiencia',
      revenue: 'Ingreso',
      perHour: '$/hora',
    },
    categoryTitle: 'Ingreso por categoría',
    ordersTitle: 'Órdenes de trabajo',
    cols: {
      date: 'Fecha',
      tnum: 'Orden',
      customer: 'Cliente',
      vehicle: 'Unidad',
      jobs: 'Trabajos',
      hours: 'Horas',
      revenue: 'Ingreso',
      status: 'Estado',
    },
    woDone: 'completada',
    woOpen: 'abierta',
    empty: 'Sin órdenes de trabajo en la ventana.',
    disabled: 'El módulo de taller no está habilitado para esta empresa. Pídelo a soporte si lo necesitas.',
    jobsLabel: 'trabajos',
    rendimiento: {
      title: 'Rendimiento',
      subtitle: 'Productividad y rentabilidad por técnico: horas estimadas vs. reales, ingreso de mano de obra, utilización diaria y regresos.',
      kpi: {
        jobs: 'Trabajos',
        efficiency: 'Eficiencia prom.',
        revenue: 'Ingreso mano de obra',
        comebackRate: 'Tasa de regresos',
        laborGp: 'Utilidad M.O.',
      },
      leaderboardTitle: 'Tabla de posiciones',
      leaderboardMetric: 'Ordenar por',
      perTechTitle: 'Detalle por técnico',
      cols: {
        tech: 'Técnico',
        jobs: 'Trabajos',
        estHrs: 'Hrs est.',
        actHrs: 'Hrs reales',
        efficiency: 'Eficiencia',
        effRate: 'Tarifa efectiva ($/h)',
        utilization: 'Utilización (h/día)',
        comebacks: 'Regresos',
        revenue: 'Ingreso',
        laborCost: 'Costo M.O.',
        laborGp: 'Utilidad M.O.',
        category: 'Categoría',
      },
      categoryMixTitle: 'Ingreso por categoría',
      categoryBreakdownTitle: 'Desglose por categoría',
      // {days} is replaced with the payload's comeback_days at render time.
      comebackDisclaimer: 'Regresos = estimación heurística (mismo vehículo y categoría dentro de {days} días); no es un dato registrado.',
      empty: 'Sin trabajos de taller en la ventana.',
    },
    cockpit: {
      views: { resumen: 'Resumen', tablero: 'Tablero', agenda: 'Agenda', orden: 'Orden 360', vehiculos: 'Vehículos', tecnicos: 'Técnicos', rendimiento: 'Rendimiento', facturar: 'Facturar', dvi: 'Inspección' },
      status: { A: 'Cita', S: 'Agendado', W: 'En proceso', H: 'En espera', bko: 'Backorder', C: 'Completada' },
      kpi: { aro: 'ORP (orden promedio)', laborRate: 'Tarifa efectiva', mix: 'Refacciones vs. mano de obra', open: 'Órdenes abiertas', revenueMtd: 'Ingreso del periodo' },
      facturar: {
        title: 'Preparar facturación',
        pickWo: 'Selecciona una orden abierta para preparar su facturación.',
        invoiced: 'Esta orden ya fue facturada — no admite más líneas de mano de obra.',
        readonly: 'Escrituras deshabilitadas — solo lectura.',
        // Mano de obra
        laborTitle: 'Mano de obra',
        laborHint: 'Agrega los trabajos a cobrar y postéalos a la orden.',
        addFromCatalog: 'Agregar del catálogo',
        suggestions: 'Sugerencias de inspección (aprobadas)',
        colJob: 'Trabajo',
        colTech: 'Técnico',
        colEstHrs: 'Hrs est.',
        colActHrs: 'Hrs reales',
        colPrice: 'Precio',
        pickJob: '(elegir trabajo)',
        pickTech: '(elegir técnico)',
        remove: 'Quitar',
        postLabor: 'Postear al WO',
        posting: 'Posteando…',
        posted: 'Líneas posteadas',
        postError: 'No se pudo postear',
        currentLabor: 'Mano de obra en la orden',
        woTotal: 'Total mano de obra',
        noRows: 'Sin líneas por postear.',
        // Refacciones
        partsTitle: 'Refacciones (lista de surtido)',
        partsHint: 'Busca refacciones para armar la lista de surtido. El mostrador captura estas refacciones en el POS.',
        partsSearch: 'Buscar refacción por descripción o número…',
        partsSearching: 'Buscando…',
        colPart: 'Refacción',
        colDesc: 'Descripción',
        colStock: 'Existencia',
        colQty: 'Cant.',
        add: 'Agregar',
        print: 'Imprimir lista',
        partsEmpty: 'Sin refacciones en la lista.',
        posNote: 'El mostrador captura estas refacciones en el POS — aquí no se escriben.',
        printTitle: 'Lista de surtido — refacciones',
        // Catálogo (crear)
        catalogTitle: 'Catálogo (crear)',
        catalogHint: 'Crea nuevos trabajos o técnicos; aparecerán en los selectores.',
        createJob: 'Crear trabajo',
        createTech: 'Crear técnico',
        jobCode: 'Código',
        jobDesc: 'Descripción',
        category: 'Categoría',
        custRate: 'Precio cliente',
        techComm: 'Tipo comisión (1-4)',
        jobLevel: 'Nivel (1-6)',
        taxable: 'Gravable',
        supplies: 'Insumos',
        custCharge: 'Se cobra al cliente',
        techCode: 'Código',
        techName: 'Nombre',
        scom: 'Comisión %',
        rateHr: 'Tarifa por hora',
        create: 'Crear',
        creating: 'Creando…',
        created: 'Creado',
        createError: 'No se pudo crear',
      },
      overdue: 'Vencida', promise: 'Promesa', writer: 'Asesor', tag: 'Etiqueta',
      laborLines: 'Mano de obra', partsLines: 'Refacciones', gp: 'Utilidad bruta', gpPct: '% utilidad',
      vehicleSearch: 'Buscar por placa, VIN o cliente…', warranty: 'Garantía', contract: 'Contrato',
      history: 'Historial de servicio', meters: 'Odómetro', commissionTitle: 'Comisiones', accrued: 'Devengado', due: 'Por pagar', paid: 'Pagado',
      agenda: {
        sinHora: 'Sin hora',
        today: 'Hoy',
        empty: 'Sin citas esta semana',
        edit: {
          title: 'Reagendar OT',
          date: 'Fecha promesa',
          time: 'Hora',
          status: 'Estado',
          tech: 'Técnico',
          none: '(sin asignar)',
          save: 'Guardar',
          cancel: 'Cancelar',
          view360: 'Ver 360',
          readonly: 'Solo lectura — escritura deshabilitada',
        },
      },
    },
  },
  pagos: {
    title: 'Aplicar pago',
    subtitle: 'Registra el pago de un cliente y aplícalo a sus facturas abiertas. Mismo flujo que el panel de Cuentas por cobrar, sin buscar la cuenta en la lista de antigüedad.',
    pickPrompt: 'Elige la cuenta a la que vas a aplicar el pago.',
  },
  statement: {
    title: 'Estado de cuenta',
    subtitle: 'Estado de cuenta de un cliente: movimientos (cargos, pagos, notas), saldo corrido y antigüedad de saldos por periodo. Mismos cálculos que el estado impreso (mexstate).',
    store: 'Tienda',
    account: 'Cuenta',
    accountPlaceholder: 'Buscar cuenta o nombre…',
    pickPrompt: 'Elige una tienda y una cuenta para ver su estado de cuenta.',
    asOf: 'Estado al',
    financeRate: 'Interés',
    downloadCsv: 'Descargar CSV',
    agingTitle: 'Antigüedad de saldos',
    overdue: 'Saldo vencido',
    ledgerTitle: 'Movimientos',
    empty: 'Sin movimientos en el periodo.',
    summary: {
      prev: 'Saldo anterior',
      charges: 'Cargos',
      credits: 'Créditos',
      payments: 'Pagos',
      other: 'Otros',
      total: 'Saldo total',
    },
    cols: {
      date: 'Fecha',
      due: 'Vence',
      type: 'Tipo',
      inum: 'Factura',
      po: 'O.C.',
      amount: 'Importe',
      balance: 'Saldo',
      running: 'Balance',
    },
    tab: 'Estado de cuenta',
  },
  transfers: {
    title: 'Traspasos entre tiendas',
    subtitle: 'Mercancía que una tienda envía a otra, valuada a costo. Compara lo enviado contra lo que la tienda destino registró como recibido — las diferencias aparecen arriba.',
    kpi: { count: 'Embarques', units: 'Unid. enviadas', recvUnits: 'Unid. recibidas', cost: 'Valor a costo' },
    route: 'Ruta',
    shipmentsTitle: 'Embarques',
    receiptsTitle: 'Recepciones en destino',
    reconTitle: 'Discrepancias por parte',
    reconSubtitle: 'Partes donde lo enviado y lo recibido no cuadran en la ventana (enviado − recibido).',
    reconClear: '✓ Sin discrepancias — todo lo enviado fue recibido.',
    reconUnavailable: 'La comparación contra recepciones aún no está configurada para esta empresa — pídelo a soporte. Mientras tanto se muestran solo los envíos.',
    cols: {
      date: 'Fecha',
      tnum: 'Ticket',
      onum: 'OC',
      from: 'Origen',
      to: 'Destino',
      slid: 'Vendedor',
      lines: 'Líneas',
      units: 'Unidades',
      cost: 'Costo',
      status: 'Estado',
      part: 'Parte',
      shipped: 'Enviado',
      received: 'Recibido',
      diff: 'Dif.',
    },
    statusDone: 'completado',
    statusOpen: 'abierto',
    empty: 'Sin traspasos en la ventana.',
  },
  customers: {
    title: 'Clientes',
    subtitle: 'Segmentación RFM: agrupa a tus cuentas según qué tan reciente compran (R), con qué frecuencia (F) y cuánto gastan (M). Solo ventas facturadas; las cuentas genéricas de mostrador se excluyen.',
    window: { d90: '90 días', d180: '180 días', d365: '12 meses' },
    searchPlaceholder: 'Buscar cuenta o nombre…',
    segmentAll: 'Todos los segmentos',
    segments: {
      champions: 'Campeones',
      loyal: 'Leales',
      recent: 'Recientes',
      big_at_risk: 'No perder',
      at_risk: 'En riesgo',
      dormant: 'Dormidos',
      regular: 'Regulares',
    },
    segmentHints: {
      champions: 'Compran seguido, hace poco y gastan fuerte.',
      loyal: 'Frecuentes y vigentes.',
      recent: 'Compraron hace poco; aún poca historia.',
      big_at_risk: 'Gastaban fuerte y dejaron de venir.',
      at_risk: 'Compraban seguido y dejaron de venir.',
      dormant: 'Sin compras recientes.',
      regular: 'A media tabla en todo.',
    },
    cols: {
      account: 'Cuenta',
      segment: 'Segmento',
      rfm: 'R·F·M',
      tickets: 'Tickets',
      revenue: 'Venta',
      lastBuy: 'Última compra',
      recency: 'Días sin comprar',
      cadence: 'Ritmo (días)',
    },
    churnBadge: 'inactivo vs su ritmo',
    kpi: { customers: 'Cuentas activas', revenue: 'Venta ventana', atRisk: 'En riesgo / no perder', churn: 'Fuera de ritmo' },
    empty: 'Sin ventas con cuenta en la ventana.',
    excludedNote: 'Cuentas genéricas excluidas de la segmentación: {list}',
    scorecard: {
      title: 'Desempeño de la cuenta',
      window: 'ventana 12 meses',
      segment: 'Segmento',
      ticketsMonth: 'Tickets / mes',
      avgTicket: 'Ticket promedio',
      lastBuy: 'Última compra',
      daysAgo: 'hace {n} días',
      cadence: 'Ritmo de compra',
      cadenceUnit: 'cada {n} días',
      openQuotes: 'Cotizaciones abiertas',
      returns90: 'Devoluciones 90d',
      returnsDetail: '{n} líneas',
      noRfm: 'Sin actividad en los últimos 12 meses (o cuenta excluida de segmentación).',
    },
  },
  quoteConv: {
    title: 'Conversión de cotizaciones',
    subtitle: 'Observada por BI cada 30 min — Pacesetter no guarda rastro de la conversión.',
    since: 'midiendo desde {date}',
    window: 'últimos {days} días',
    kpi: {
      rate: 'Tasa de conversión',
      converted: 'Convertidas',
      abandoned: 'Abandonadas',
      avgDays: 'Días promedio',
      convertedMxn: '$ convertido',
    },
    cols: {
      slid: 'Vendedor',
      created: 'Creadas',
      converted: 'Convertidas',
      abandoned: 'Abandonadas',
      open: 'Abiertas',
      rate: 'Tasa',
      avgDays: 'Días prom.',
      mxn: '$ convertido',
    },
    pending: 'Aún sin resoluciones en la ventana — las cotizaciones que se conviertan o abandonen aparecerán aquí.',
  },
  config: {
    title: 'Configuración',
    subtitle: 'Ajustes del sistema. Por ahora, retención y comportamiento de los respaldos (Archivos).',
    archiveTitle: 'Respaldos / Archivos',
    archiveSubtitle: 'Cuánto tiempo se conservan los respaldos antes de moverse a frío y borrarse. Los cambios aplican en el siguiente respaldo automático.',
    notConfigured: 'No hay respaldos configurados en este servidor (falta archive.ini). Pídelo a soporte.',
    secretsNote: 'Los datos sensibles (destino SFTP, credenciales, notificaciones) se siguen configurando en el servidor — aquí solo se ajusta retención y comportamiento.',
    cols: {
      stream: 'Flujo',
      mode: 'Modo',
      hotDays: 'Días en caliente',
      coldDays: 'Retención (días)',
    },
    mode: { rotate: 'Rotación', snapshot: 'Instantánea' },
    hotHint: 'Días que el archivo más reciente permanece accesible antes de moverse a frío.',
    coldHint: 'Días totales que se conserva antes de borrarse. 1825 = 5 años (requisito SAT).',
    satWarn: '⚠ Debajo de 1825 días (5 años) — por debajo del mínimo recomendado por el SAT.',
    coldLtHot: 'La retención debe ser mayor o igual a los días en caliente.',
    save: 'Guardar cambios',
    saved: 'Cambios guardados. Aplican en el próximo respaldo.',
    streamNames: {
      inventory_snapshot: 'Inventario (snapshot diario)',
      inventory_history: 'Inventario (histórico)',
    },
  },
  exceptions: {
    title: 'Atención',
    window: 'últimos {days} días ({from} – {to})',
    daemonDown: 'KPIs en vivo no disponibles (paceAPIserv fuera de línea) — se muestran solo los datos del último snapshot.',
    allClear: '✓ Sin excepciones — métricas dentro de meta.',
    fill: {
      label: 'Surtido en mostrador',
      target: 'meta >95%',
      detail: '{sold} líneas vendidas · {lost} perdidas',
      noData: 'sin movimientos en la ventana',
    },
    dead: {
      label: 'Inventario muerto',
      target: 'meta <10% · alarma 25%',
    },
    turn: {
      label: 'Rotación anualizada',
      target: 'sano 4–6×',
    },
    stockouts: {
      title: 'Clase A sin existencia',
      subtitle: 'SKUs clase A con existencia 0 — venta directa que se está escapando.',
      colPart: 'Parte',
      colDesc: 'Descripción',
      colStore: 'Tienda',
      colUnits: 'Unid. 90d',
      more: '… y {n} más',
    },
    lowMargin: {
      title: 'Tiendas bajo margen',
      subtitle: 'Margen 30d al menos 5 puntos debajo de la cadena.',
      chain: 'cadena {pct}',
    },
    arRisk: {
      title: 'Cartera 90+ días',
      subtitle: 'Cuentas con saldo vencido a más de 90 días.',
      colAccount: 'Cuenta',
      col90: 'Saldo 90+',
      colTotal: 'Saldo total',
    },
  },
  access: {
    title: 'Sección no disponible',
    noAccess: 'Esta sección no está disponible para tu rol ({you}).',
    requires: 'Esta sección requiere rol {role}. Tu rol actual es {you}.',
    availableFor: 'Disponibles para ti:',
    goHome: 'Ir al tablero',
  },
  tour: {
    startButton: 'Mostrar guía de esta página',
    next: 'Siguiente',
    prev: 'Anterior',
    skip: 'Saltar',
    done: 'Listo',
    dontShowAgain: 'No volver a mostrar',
    of: 'de',
  },
  support: {
    openButton: 'Ayuda y soporte',
    drawerTitle: 'Ayuda y soporte',
    tabHelp: 'Ayuda',
    tabSupport: 'Reportar problema',
    title: 'Reportar un problema',
    subtitle: 'Describe lo que viste y qué esperabas. El equipo de soporte recibe el ticket al instante.',
    fieldTitle: 'Asunto',
    fieldBody: '¿Qué pasó? ¿Qué esperabas?',
    titlePlaceholder: 'Ej: "No se ven mis ventas de hoy"',
    bodyPlaceholder: 'Pasos para reproducirlo, mensajes de error, etc.',
    submit: 'Enviar',
    errorRequired: 'Asunto y descripción son requeridos.',
    thanksTitle: '¡Ticket enviado!',
    thanksBody: 'Te contactaremos pronto. Guarda el número de ticket por si necesitas hacer seguimiento:',
    attached: 'Adjuntaremos automáticamente:',
    attachedPage: 'Página',
    attachedUser: 'Usuario',
    attachedError: 'Último error',
    kindLabel: '¿Qué tipo de reporte es?',
    kindBug: 'Falla',
    kindSuggestion: 'Sugerencia',
    kindQuestion: 'Pregunta',
    urgent: 'No puedo trabajar por esto (urgente)',
    thanksLinear: 'Tu número de ticket:',
    thanksPending: 'Lo enviaremos al equipo de soporte en cuanto haya conexión.',
  },
  // Customer ticket board (Linear JCD-20/JCD-21) — a site's own JCD tickets
  // as a status board with a comment thread (/soporte/tickets). Distinct
  // from `support` above (the "report a problem" ticket-creation form the
  // drawer's Reportar problema tab uses) and from `ticket` below (POS sales
  // ticket detail) — this block is read/follow/reply on tickets that already
  // exist.
  supportTickets: {
    title: 'Mis tickets de soporte',
    subtitle: 'Tickets abiertos con el equipo de soporte para este sitio. Da seguimiento al estado y comenta directamente aquí.',
    reportButton: 'Reportar un problema',
    loading: 'Cargando tickets…',
    empty: 'Todavía no hay tickets de soporte para este sitio.',
    offlineTitle: 'Mostrando la última copia guardada',
    offlineBody: 'No se pudo contactar al servidor de licencias; el estado y los mensajes pueden estar desactualizados.',
    columns: {
      received: 'Recibido',
      in_progress: 'En progreso',
      done: 'Listo',
      closed: 'Cerrado',
    },
    kind: {
      bug: 'Falla',
      suggestion: 'Sugerencia',
      question: 'Pregunta',
      report: 'Reporte',
    },
    reporter: 'Reportado por',
    created: 'Creado',
    updated: 'Actualizado',
    unreadLabel: 'sin leer',
    detailTitle: 'Detalle del ticket',
    conversation: 'Conversación',
    noMessages: 'Sin mensajes todavía.',
    team: 'Equipo de soporte',
    commentPlaceholder: 'Escribe un comentario…',
    send: 'Enviar',
    commentSent: 'Comentario enviado.',
    commentFailed: 'No se pudo enviar el comentario',
  },
  roles: {
    owner: 'Dueño',
    manager: 'Gerente',
    staff: 'Mostrador',
    accounting: 'Contabilidad',
    counterman: 'Terminal',
  },
  nav: {
    overview: 'Resumen',
    dashboard: 'Mi tablero',
    sales: 'Ventas',
    parts: 'Partes',
    inventory: 'Inventario',
    vendors: 'Proveedores',
    salespeople: 'Vendedores',
    customers: 'Clientes',
    ar: 'CXC',
    cxcList: 'Cuentas por cobrar',
    lost: 'Perdidas',
    service: 'Taller',
    statement: 'Estado de cuenta',
    reports: 'Reportes',
    archives: 'Archivos',
    admin: 'Administración',
    adminUsers: 'Usuarios',
    terminalUsers: 'Usuarios de Terminal',
    writeAudit: 'Auditoría',
    config: 'Configuración',
    purchasing: 'Compras',
    payables: 'Cuentas por Pagar',
    cxp: 'CXP',                 // short top-bar label for /pagar (pairs with `ar: 'CXC'`)
    pagos: 'Aplicar pago',      // Clientes menu → /pagos
    caja: 'Caja',
    movil: 'Móvil',
    anticipos: 'Anticipos',
    priceUploads: 'Precios',
    discrepancias: 'Discrepancias',
    conteoFisico: 'Conteo físico',
    pacesetter: 'Pacesetter',
    supportTickets: 'Tickets de soporte',
    logout: 'Salir',
  },
  quotes: {
    title: 'Cotizaciones abiertas',
    subtitle: 'Cotizaciones guardadas que todavía no se facturan. Cuando una se convierte en venta desaparece de esta lista — la tarjeta de conversión de abajo mide qué tantas terminan en venta.',
    empty: 'Sin cotizaciones abiertas en este rango.',
    kpi: {
      open:  'Cotizaciones',
      total: 'Total cotizado',
    },
    aging: {
      all:   'Toda',
      fresh: 'Fresca (≤7d)',
      aging: 'Madurando (7-30d)',
      stale: 'Vieja (>30d)',
    },
    state: {
      open:      'Abierta',
      converted: 'Convertida',
      invoiced:  'Facturada',
    },
    cols: {
      cdate:   'Fecha',
      tnum:    'Coti #',
      account: 'Cliente',
      store:   'Tienda',
      slid:    'Vendedor',
      lines:   'Líneas',
      subt:    'Total',
      days:    'Días abierta',
      aging:   'Antigüedad',
      state:   'Estado',
    },
    detail: {
      title:  'Detalle de cotización',
      lines:  'Renglones',
    },
  },
  returns: {
    salesTitle: 'Devoluciones de clientes',
    salesSubtitle: 'Mercancía que los clientes regresaron: notas de crédito, cores, garantías y defectos.',
    purchasingTitle: 'Devoluciones a proveedores',
    purchasingSubtitle: 'Renglones de recepción con cantidad negativa (devolución al proveedor).',
    empty: 'Sin devoluciones en este rango.',
    cols: {
      date:        'Fecha',
      ticket:      'Ticket',
      account:     'Cuenta',
      store:       'Tienda',
      slid:        'Vendedor',
      part:        'Parte',
      pdesc:       'Descripción',
      qty:         'Cant.',
      sell:        'Importe',
      pcost:       'Costo',
      reason:      'Razón',
      onum:        'OC#',
      recvNo:      'Recep #',
      sup:         'Proveedor',
      cost:        'Costo unit.',
      ext:         'Subtotal',
    },
    reasons: {
      all:      'Todas',
      core:     'Core',
      defect:   'Defecto',
      warranty: 'Garantía',
      other:    'Otro',
    },
  },
  // Cuentas por Pagar (supplier payables).
  payables: {
    title: 'Cuentas por Pagar',
    upload: 'Subir factura',
    uploadHint: 'Adjunte el XML del CFDI y/o el PDF de la factura.',
    xmlLabel: 'XML (CFDI)',
    pdfLabel: 'PDF (opcional)',
    dropHint: 'Arrastre el archivo aquí',
    browseLabel: 'o seleccione uno',
    uploadNote: 'Con el XML los datos se llenan solos. Con sólo el PDF, la factura queda pendiente de captura.',
    parsing: 'Procesando XML…',
    parseFailed: 'No se pudo procesar el XML',
    porPagar: 'Por pagar',
    saldo: 'Saldo',
    vence: 'Vence',
    proveedor: 'Proveedor',
    factura: 'Factura',
    folio: 'Folio',
    fecha: 'Fecha',
    moneda: 'Moneda',
    tipoCambio: 'T.C.',
    subtotal: 'Subtotal',
    impuestos: 'IVA',
    descuento: 'Descuento',
    total: 'Total',
    estado: 'Estado',
    conceptos: 'Conceptos',
    addLine: '+ agregar línea',
    cantidad: 'Cant',
    unidad: 'Unid',
    descripcion: 'Descripción',
    valorUnitario: 'P. Unit',
    importe: 'Importe',
    orden: 'Orden (PO)',
    notas: 'Notas',
    guardar: 'Guardar',
    // Distinct from `guardar` on purpose: the detail page shows the capture
    // form and the payment form at once, and two identical "Guardar" buttons
    // leave the user guessing which one they are about to press.
    guardarPago: 'Guardar pago',
    cancelar: 'Cancelar',
    cancelInvoice: 'Cancelar factura',
    registrarPago: 'Registrar pago',
    pagos: 'Pagos',
    metodo: 'Método',
    referencia: 'Referencia',
    banco: 'Banco',
    anular: 'Anular',
    anulado: 'Anulado',
    motivo: 'Motivo',
    // Sent as the void reason when the user does not type one. Deliberately a
    // separate string from `motivo` (a field LABEL) so the audit log never
    // records the literal word "Motivo" as somebody's reason.
    voidDefaultReason: 'Anulado desde paceBI',
    descargarXml: 'Descargar XML',
    descargarPdf: 'Descargar PDF',
    proveedores: 'Proveedores',
    sinVincular: 'Proveedores sin vincular',
    sinVincularHint: 'Vincule el RFC con un proveedor de Pacesetter una vez y todas sus facturas quedan ligadas.',
    vincular: 'Vincular',
    rfc: 'RFC',
    diasCredito: 'Días de crédito',
    facturasActualizadas: 'facturas actualizadas',
    status: {
      pendiente: 'Pendiente de datos',
      abierta: 'Abierta',
      parcial: 'Parcial',
      pagada: 'Pagada',
      cancelada: 'Cancelada',
    },
    buckets: {
      por_vencer: 'Por vencer',
      '1-30': '1-30 días',
      '31-60': '31-60 días',
      '61-90': '61-90 días',
      '90+': '+90 días',
    },
    empty: 'No hay facturas de proveedor registradas.',
    credito: 'Nota de crédito',
  },

  purchasing: {
    tabs: {
      suppliers:  'Proveedores',
      purchases:  'Órdenes',
      receptions: 'Recepciones',
      returns:    'Devoluciones',
    },
    purchases: {
      title: 'Órdenes de compra',
      subtitle: 'Historial de OC al proveedor (no incluye traspasos entre tiendas).',
      empty: 'Sin órdenes en este rango.',
      cols: {
        date:     'Fecha',
        onum:     'OC#',
        sup:      'Proveedor',
        store:    'Tienda',
        lines:    'Líneas',
        qtyOrd:   'Cant. ord',
        qtyRcv:   'Cant. rec',
        cost:     'Costo',
        status:   'Estado',
        lastRecv: 'Última recep.',
      },
      status: {
        all:     'Todos',
        open:    'Abierta',
        partial: 'Parcial',
        closed:  'Cerrada',
      },
      export: {
        csv: 'Descargar CSV',
        pdf: 'Descargar PDF',
      },
      email: {
        button:        'Enviar por correo',
        title:         'Enviar orden de compra',
        to:            'Correo del proveedor',
        toPlaceholder: 'proveedor@ejemplo.com',
        includePdf:    'Incluir PDF',
        send:          'Enviar',
        cancel:        'Cancelar',
        sent:          'Correo enviado.',
        invalidEmail:  'Correo inválido.',
      },
      detail: {
        title:   'Detalle de OC',
        header:  'Encabezado',
        lines:   'Renglones',
        receipts:'Recepciones',
      },
    },
    receptions: {
      title: 'Recepciones',
      subtitle: 'Eventos de recibo contra OC. Una OC puede tener varias recepciones.',
      empty: 'Sin recepciones en este rango.',
      cols: {
        date:     'Fecha',
        onum:     'OC#',
        recvNo:   'Recep #',
        sup:      'Proveedor',
        store:    'Tienda',
        lines:    'Líneas',
        qtyRecv:  'Cant. rec',
        qtyOrd:   'OC pedida',
        pct:      'Completitud',
      },
      completeness: {
        all:   'Todas',
        short: 'Corta',
        full:  'Completa',
        over:  'Sobrante',
      },
      detail: {
        title: 'Detalle de recepción',
      },
    },
  },
  admin: {
    pageTitle: 'Usuarios',
    pageSubtitle: 'Crea, edita y elimina los usuarios que pueden acceder a BI. El límite depende del número de plazas contratadas.',
    seatsUsed: '{used} de {allowed} plazas usadas',
    seatsExpires: 'vence {date}',
    trialBadge: 'modo prueba',
    licenseGrace: 'Licencia vencida; quedan días de gracia. Renueva antes de poder crear usuarios nuevos.',
    licenseExpired: 'Licencia vencida. No se pueden crear nuevos usuarios.',
    // Status-neutral fallback for the "＋ Agregar usuario" tooltip when
    // writes are license-blocked for a reason OTHER than a plain expiry
    // (cannot_validate/misconfigured/clock_skew all block writes too — see
    // licenseAllowsWrites in lib/roles.ts) and that specific status isn't
    // one AdminUsers.tsx branches on by name. Prefer the distinct
    // licenseBanner.* copy below when the status IS known.
    licenseWriteBlocked: 'La licencia no permite escrituras en este momento.',
    addUser: 'Agregar usuario',
    addUserDisabledLimit: 'Límite de plazas alcanzado',
    columns: {
      username: 'Usuario',
      role: 'Rol',
      sid: 'Tienda',
      email: 'Correo (acceso remoto)',
      createdAt: 'Creado',
      actions: '',
    },
    actions: {
      edit: 'Editar',
      delete: 'Eliminar',
      resetPassword: 'Restablecer contraseña',
    },
    dialog: {
      titleCreate: 'Nuevo usuario',
      titleEdit: 'Editar usuario',
      username: 'Usuario',
      password: 'Contraseña',
      passwordPlaceholder: 'Mínimo 8 caracteres',
      passwordNewOnly: 'Sólo si quieres cambiarla',
      role: 'Rol',
      sid: 'Tienda asignada (sid)',
      sidHint: 'Requerido sólo para rol mostrador.',
      email: 'Correo (acceso remoto)',
      emailPlaceholder: 'nombre@empresa.com',
      emailHint: 'Opcional. Con correo, el usuario puede entrar desde fuera en pacebi.ddns.net/acceso.',
      save: 'Guardar',
      cancel: 'Cancelar',
    },
    confirmDelete: '¿Eliminar al usuario {username}?',
    remote: {
      title: 'Acceso remoto',
      synced: 'sincronizado {when} · {n} usuarios',
      never: 'aún no sincronizado',
      syncing: 'sincronizando…',
      syncNow: 'Sincronizar ahora',
      justNow: 'hace un momento',
      minutesAgo: 'hace {n} min',
      hoursAgo: 'hace {n} h',
      errors: {
        remote_disabled: 'no habilitado para tu empresa; contacta a soporte.',
        unreachable: 'no se pudo contactar el servicio; reintentando.',
        unauthorized: 'el servicio rechazó las credenciales de licencia.',
        too_many_users: 'demasiados usuarios con correo (máximo 500).',
        server_error: 'error del servicio; reintentando.',
        generic: 'error de sincronización.',
      },
      rejected: {
        in_use_by_other_customer: 'correo en uso por otro cliente',
        invalid_email: 'correo inválido',
      },
    },
    permsSection: 'Permisos personalizados',
    permsHint: 'Activa permisos adicionales además de los que otorga el rol.',
    permsRoleLocked: 'Concedido por el rol',
    permsGroups: {
      areas:     'Áreas',
      drilldown: 'Detalle',
      sensitive: 'Datos sensibles',
      archives:  'Archivos',
      features:  'Funciones',
      admin:     'Administración',
    },
    permsLabels: {
      'view:overview':        'Resumen',
      'view:sales':           'Ventas',
      'view:parts':           'Partes',
      'view:ar':              'Cuentas por cobrar',
      'view:lost':            'Ventas perdidas',
      'view:inventory':       'Inventario',
      'view:vendors':         'Compras / proveedores',
      'view:salespeople':     'Vendedores',
      'view:customer.detail': 'Detalle de cliente',
      'view:part.detail':     'Detalle de parte',
      'view:archive':         'Archivos JSON',
      'archive:download':     'Descargar archivos',
      'cost:visible':         'Ver costo',
      'invoice:download':     'Descargar CFDI XML/PDF',
      'reports:use':          'Reportes',
      'user:seed':            'Administrar usuarios',
    },
    errors: {
      seatLimit: 'Se alcanzó el número máximo de plazas. Elimina un usuario o agrega plazas.',
      licenseExpired: 'La licencia está vencida. Contacta a soporte para renovarla.',
      lastOwner: 'No se puede eliminar al último dueño.',
      usernameTaken: 'Ese usuario ya existe.',
      passwordShort: 'La contraseña debe tener al menos 8 caracteres.',
      emailTaken: 'Ese correo ya está asignado a otro usuario.',
      emailInvalid: 'El correo no es válido.',
      generic: 'No se pudo completar la acción.',
    },
  },
  terminalUsers: {
    pageTitle: 'Usuarios de Terminal',
    pageSubtitle: 'Usuarios que pueden iniciar sesión en el terminal web de Pacesetter, y a qué caja (PACETTY) se conecta cada uno.',
    addUser: 'Agregar usuario',
    columns: {
      username: 'Usuario',
      fullName: 'Nombre',
      pacetty: 'PACETTY',
      status: 'Estado',
      actions: '',
    },
    status: {
      active: 'Activo',
      inactive: 'Inactivo',
    },
    actions: {
      edit: 'Editar',
      delete: 'Eliminar',
      webPassword: 'Contraseña web',
      provision: 'Terminal e impresoras',
      operator: 'Operador ERP',
    },
    dialog: {
      titleCreate: 'Nuevo usuario de terminal',
      titleEdit: 'Editar usuario de terminal',
      username: 'Usuario',
      fullName: 'Nombre completo',
      pacetty: 'PACETTY',
      pacettyHint: 'Terminal o caja a la que se conecta la sesión web de este usuario (ej. net149). Déjalo en blanco para usar una sesión genérica.',
      status: 'Estado',
      save: 'Guardar',
      cancel: 'Cancelar',
      webPasswordTitle: 'Contraseña web de {username}',
      webPasswordHint: 'Esta es la contraseña para entrar al terminal web (aquí, en pacebi). Es independiente de la clave de operador que se teclea en la pantalla verde de Pacesetter/ERP.',
      newPassword: 'Nueva contraseña',
      confirmPassword: 'Confirmar contraseña',
      passwordPlaceholder: 'Mínimo 8 caracteres',
      passwordMismatch: 'Las contraseñas no coinciden.',
      passwordTooShort: 'La contraseña debe tener al menos 8 caracteres.',
    },
    confirmDelete: '¿Eliminar al usuario de terminal {username}?',
    webPasswordSet: 'Contraseña web actualizada para {username}.',
    empty: 'Sin usuarios de terminal registrados todavía.',
    errors: {
      generic: 'No se pudo completar la acción.',
    },
    provision: {
      title: 'Terminal e impresoras — {startdev}',
      hint: 'Define la tienda y el ruteo de impresoras del registro (startup.p) para este PACETTY.',
      sid: 'Tienda (sid)',
      prlocal: 'Impresora local (prlocal)',
      prnorecpt: 'Sin recibo (prnorecpt)',
      localForm: 'Formato local',
      none: 'Ninguna (0)',
      loading: 'Cargando impresoras y configuración…',
      saved: 'Terminal e impresoras actualizado para {startdev}.',
      slots: [
        'Administración',
        'Inventario',
        'CxC',
        'Ticket',
        'Factura POS',
        'Recibo caja',
        'Etiqueta',
        'Cierre',
        'Factura SS/OT',
        'Nota crédito POS',
        'Recibo ROA',
      ],
    },
    provisionScript: {
      button: 'Descargar script de alta (SO)',
      hint: 'Genera el script (useradd + /icas/logins) para ejecutar como root.',
      downloaded: 'Script de alta descargado.',
      errorPrefix: 'No se pudo generar el script: ',
    },
    operator: {
      title: 'Operador ERP (pantalla verde) — {username}',
      userid: 'Usuario ERP (userid)',
      password: 'Contraseña ERP',
      hint: 'Crea la cuenta con la que este usuario inicia sesión en la pantalla verde de Pacesetter (SETUSERID) — es independiente de su contraseña web de arriba. El operador puede cambiar su propia contraseña desde la pantalla verde después de este alta.',
      created: 'Operador ERP creado: {userid}.',
      useridRequired: 'El usuario ERP es requerido.',
    },
  },
  login: {
    title: 'Iniciar sesión',
    username: 'Usuario',
    password: 'Contraseña',
    submit: 'Entrar',
    signingIn: 'Entrando…',
    invalid: 'Usuario o contraseña incorrectos',
  },
  filter: {
    allStores: 'Todas las tiendas',
    store: 'Tienda',
  },
  // Pager strip under long tables (components/Pagination.tsx). Composed in
  // the component: "Mostrando 1–50 de 1,234" / "Página 2 de 25".
  pagination: {
    showing: 'Mostrando',
    of: 'de',
    page: 'Página',
    prev: 'Anterior',
    next: 'Siguiente',
    perPage: 'Filas por página',
  },
  // Shared CSV / PDF export pair (components/ExportButtons.tsx).
  exportButtons: {
    csv: 'Descargar CSV',
    pdf: 'Descargar PDF',
  },
  kpi: {
    salesToday: 'Ventas de hoy',
    tickets: 'tickets',
    vsYesterday: 'vs ayer',
    grossMargin: 'Margen bruto',
    arTotal: 'Cuentas por cobrar',
    inventory: 'Inventario al costo',
    lowStock: 'bajo mínimo',
    /** Tile label when inventory cost is hidden for Staff. */
    lowStockMetric: 'Bajo mínimo',
    /** Sub-text on the low-stock tile when shown alone. */
    parts: 'partes',
    /** Hint shown above KPIs when a single-store filter is active on a
     *  multi-store customer — KPIs are still chain-wide because the backend
     *  doesn't (yet) serve per-store totals. */
    chainWideHint: 'Indicadores generales — toda la empresa',
  },
  charts: {
    salesTodayTitle: 'Ventas por hora',
    salesTodaySubtitle: 'Hoy vs misma fecha semana pasada',
    salesPeriodTitle: 'Ventas',
    clickHourHint: 'toca una barra para ver detalle',
    salesByStoreTitle: 'Ventas por tienda — hoy',
  },
  tables: {
    topPartsTitle: 'Top 10 partes (últimos 7 días)',
    topCustomersTitle: 'Top 10 clientes (últimos 30 días)',
    lowStockTitle: 'Bajo mínimo',
    slowMoversTitle: 'Movimiento lento (sin venta 60+ días)',
    empty: 'Sin datos en este periodo.',
    emptyLowStock: '¡Nada bajo mínimo! El inventario está sano.',
    emptySlowMovers: 'Sin productos lentos. El inventario rota bien.',
    cols: {
      part: 'Parte',
      description: 'Descripción',
      qty: 'Cant.',
      revenue: 'Ingreso',
      account: 'Cuenta',
      name: 'Nombre',
      ticketCount: 'Tickets',
      onHand: 'Existencia',
      min: 'Mínimo',
      lastSold: 'Última venta',
      store: 'Tienda',
      value: 'Valor',
      daysIdle: 'Días sin venta',
    },
  },
  freshness: {
    asOf: 'Datos al',
    never: 'sin datos',
  },
  dashboard: {
    loading: 'Cargando tablero…',
    errorTitle: 'No se pudo cargar el tablero',
    retry: 'Reintentar',
    refresh: 'Actualizar',
    chainWideCalloutTitle: 'Indicadores generales',
    // Body of the callout when a store filter is active. Operational tables
    // filter to the picked store; headline KPIs stay chain-wide because the
    // server pre-aggregates them — calling it out so the user doesn't read
    // the numbers as per-store.
    chainWideCalloutBody: 'Las cifras del encabezado y las gráficas son de toda la cadena. Solo las listas de partes y existencias respetan el filtro de tienda.',
    // v2.75: shown instead of the callout when the export carries the picked
    // store's own slice — everything is per store except receivables.
    arChainWideNote: 'Cuentas por cobrar se muestra a nivel cadena: las cuentas pertenecen a clientes, no a tiendas.',
  },
  series: {
    today: 'Hoy',
    lastWeek: 'Semana pasada',
    revenue: 'Ingreso',
  },
  sales: {
    tabs: {
      sales:   'Ventas',
      returns: 'Devoluciones',
      quotes:  'Cotizaciones',
    },
    title: 'Ventas — detalle',
    subtitle: 'Cada ticket facturado en el rango: quién compró, cuánto y si ya está pagado. Toca un renglón para ver las partidas.',
    fromTo: 'Rango',
    typeFilter: 'Tipo',
    typeAll: 'Todos',
    typeCash: 'Contado',
    typeCredit: 'Crédito',
    paidFilter: 'Pago',
    paidAll: 'Todos',
    paidUnpaid: 'Pendientes',
    paidPaid: 'Pagados',
    cols: {
      date: 'Fecha',
      ticket: 'Ticket',
      account: 'Cuenta',
      store: 'Tienda',
      slid: 'Vendedor',
      subt: 'Subtotal',
      tax: 'IVA',
      total: 'Total',
      type: 'Tipo',
      paid: 'Pagado',
      balance: 'Saldo',
    },
    badge: {
      cash: 'Contado',
      credit: 'Crédito',
      debit: 'NC',
      paid: 'Pagado',
      unpaid: 'Pendiente',
    },
    unpaidLabel: 'Pendiente',
    tableHint: 'Toca un renglón para ver detalle del ticket.',
    empty: 'Sin tickets en el rango seleccionado.',
    // Server-side range summary (fast path for wide windows).
    summary: {
      loading: 'Calculando resumen del rango…',
      hint: 'Resumen calculado en el servidor sobre todos los tickets del rango. El detalle de abajo tarda más en rangos amplios.',
      tickets: 'Tickets',
      sales: 'Ventas',
      cash: 'Contado',
      credit: 'Crédito',
      pending: 'Pendiente de cobro',
      pendingWaiting: 'al cargar el detalle',
      tableLoading: 'Cargando detalle de tickets… en rangos amplios puede tardar hasta un minuto.',
      detailLoaded: '{n} tickets en el detalle',
      detailCapped: 'El detalle se limita a {n} tickets; el resumen sí incluye todos.',
      paidFilterNote: 'Con filtro de pago activo se muestra solo el detalle (el resumen no aplica ese filtro).',
    },
  },
  parts: {
    title: 'Partes — búsqueda',
    subtitle: 'Busca cualquier número de parte y revisa existencia y mínimos por tienda, en vivo.',
    searchPlaceholder: 'Buscar por número de parte…',
    kindFilter: 'Filtro',
    kindAll: 'Todas',
    kindLow: 'Bajo mínimo',
    lineFilter: 'Línea',
    pcodeFilter: 'Pcode',
    classFilter: 'Clase',
    codeFilter: 'Código',
    allLines: 'Todas las líneas',
    allPcodes: 'Todos los pcodes',
    allClasses: 'Todas las clases',
    allCodes: 'Todos los códigos',
    cols: {
      part: 'Parte',
      description: 'Descripción',
      store: 'Tienda',
      onHand: 'Existencia',
      min: 'Mínimo',
      kind: 'Estado',
      line: 'Línea',
      pcode: 'Pcode',
      class: 'Clase',
    },
    kindBadge: {
      low: 'Bajo mínimo',
      normal: 'Normal',
    },
    empty: 'Sin resultados.',
    typeToSearch: 'Escribe para buscar.',
  },
  ar: {
    title: 'Cuentas por cobrar',
    subtitle: 'Quién te debe y desde cuándo. Las columnas separan el saldo por antigüedad — lo de 90+ días es lo más urgente de cobrar.',
    statementLink: 'estado de cuenta',
    searchPlaceholder: 'Buscar cuenta…',
    sort: 'Ordenar',
    sortTotal: 'Saldo total',
    sortAging90: 'Mora 90+',
    sortName: 'Cuenta',
    cols: {
      account: 'Cuenta',
      name: 'Nombre',
      total: 'Saldo',
      b0_30: '0-30',
      b31_60: '31-60',
      b61_90: '61-90',
      b90p: '90+',
    },
    empty: 'Sin cuentas con saldo.',
  },
  ticket: {
    title: 'Ticket',
    close: 'Cerrar',
    date: 'Fecha y hora',
    account: 'Cuenta',
    store: 'Tienda',
    salesperson: 'Vendedor',
    invoice: 'Factura (inum)',
    type: 'Tipo',
    subt: 'Subtotal',
    tax: 'IVA',
    total: 'Total',
    paid: 'Pagado',
    balance: 'Saldo',
    lines: 'Partidas',
    payments: 'Pagos aplicados',
    noPayments: 'Sin pagos aplicados todavía.',
    col: {
      line: 'Línea',
      part: 'Parte',
      pdesc: 'Descripción',
      qty: 'Cant.',
      sell: 'Precio',
      pcost: 'Costo',
      extended: 'Extendido',
      tdate: 'Fecha',
      amount: 'Monto',
    },
    download: {
      xml: 'CFDI XML',
      pdf: 'PDF',
      view: 'Ver CFDI',
      missing: 'Archivo no disponible',
      notConfigured: 'Descarga no configurada en este servidor',
    },
  },
  cfdi: {
    title: 'Comprobante Fiscal',
    stamped: 'Timbrado',
    unstamped: 'Sin timbrar',
    serieFolio: 'Serie · Folio',
    fecha: 'Fecha',
    moneda: 'Moneda',
    total: 'Total',
    subtotal: 'Subtotal',
    formaPago: 'Forma de pago',
    metodoPago: 'Método de pago',
    lugarExpedicion: 'Lugar de expedición',
    emisor: 'Emisor',
    receptor: 'Receptor',
    rfc: 'RFC',
    regimenFiscal: 'Régimen fiscal',
    regimenFiscalRec: 'Régimen fiscal',
    usoCFDI: 'Uso del CFDI',
    domicilioFiscalRec: 'Domicilio fiscal',
    conceptos: 'Conceptos',
    noConceptos: 'Este comprobante no tiene conceptos.',
    impuestosTrasladados: 'IVA trasladado',
    impuestosRetenidos: 'Retenciones',
    selloFiscal: 'Sello fiscal',
    fechaTimbrado: 'Fecha de timbrado',
    noCertificadoSat: 'No. certificado SAT',
    noCertificado: 'No. certificado',
    relacionados: 'CFDIs relacionados',
    rawXml: 'Ver XML crudo',
    col: {
      identificador: 'Código',
      descripcion: 'Descripción',
      cantidad: 'Cant.',
      unidad: 'Unidad',
      valorUnitario: 'Valor unitario',
      importe: 'Importe',
      tipoRelacion: 'Tipo',
    },
  },
  chartToggle: {
    bar: 'Barras',
    pie: 'Pastel',
    empty: 'Sin datos.',
  },
  storeDrill: {
    title: 'Ventas',
    store: 'Tienda',
  },
  lost: {
    title: 'Ventas perdidas',
    subtitle: 'Lo que los clientes pidieron y no pudiste surtir. Cada línea es una venta que se escapó — úsala para decidir qué resurtir.',
    fromTo: 'Rango',
    summary: 'líneas',
    unitsSuffix: 'unidades',
    lostSuffix: 'perdido',
    cols: {
      date: 'Fecha',
      ticket: 'Ticket',
      account: 'Cuenta',
      store: 'Tienda',
      slid: 'Vendedor',
      part: 'Parte',
      pdesc: 'Descripción',
      lsqty: 'Cant. perdida',
      sell: 'Precio',
      value: 'Valor perdido',
      lostCount: 'Veces perdida',
      ytdhits: 'Hits (año)',
      curhits: 'Hits (periodo)',
    },
    empty: 'Sin ventas perdidas en el rango seleccionado.',
  },
  lineDrill: {
    title: 'Línea {line} — top partes',
    subtitle: 'Top {n} partes contribuyen {topTotal} de {total} en la línea ({pct}).',
    empty: 'Sin ventas para la línea {line} en el rango.',
    top20Title: 'Top 20 partes por ingreso',
    trendTitle: 'Tendencia diaria — top 20 vs resto de la línea',
    trendTooShort: 'Necesitas al menos 2 días con ventas para mostrar la tendencia.',
    trend: {
      top20: 'Top 20',
      rest:  'Resto de la línea',
    },
  },
  hourDrill: {
    title: 'Ventas',
    hourPrefix: 'Hora',
    summary: 'Tickets',
    revenue: 'Ingreso',
    byType: 'Por tipo',
    byLine: 'Por línea',
    bySalesperson: 'Por vendedor',
    byPaid: 'Pagados vs pendientes',
    typeCash: 'Contado',
    typeCredit: 'Crédito',
    typeCashDebit: 'Contado (NC)',
    typeCreditDebit: 'Crédito (NC)',
    paid: 'Pagados',
    unpaid: 'Pendientes',
    cashAlwaysPaid: 'Contado (cobrado)',
    noSlid: 'Sin vendedor',
  },
  errors: {
    daemonOffline: 'Servicio de consultas en vivo no disponible. Intenta de nuevo en unos minutos.',
    daemonError: 'Error al consultar Pacesetter. Vuelve a cargar la página.',
    // Shown instead of the browser's raw abort message ("signal is aborted…").
    timedOut: 'La consulta tardó más de lo esperado y se canceló. El servidor sigue procesándola en segundo plano: reintenta en unos segundos — la siguiente carga suele ser inmediata.',
    // {verb} = friendly query name, {secs} = seconds running. Appended when
    // /api/activity/busy reports a heavy query occupying the daemon.
    serverBusy: 'El servidor está ocupado con una consulta pesada ({verb}, {secs} s en curso). Los datos cargan uno a la vez; reintenta al terminar.',
  },
  activity: {
    title: 'Actividad del servidor',
    subtitle: 'Pacesetter atiende una consulta a la vez: una consulta pesada de un usuario hace lentos a los demás. Aquí se ve quién ejecuta qué, en vivo.',
    idle: 'Sin consultas en curso',
    busyCount: '{n} en curso',
    colUser: 'Usuario',
    colWhat: 'Consulta',
    colRunning: 'Corriendo',
    colTook: 'Duró',
    recentTitle: 'Recientes',
    failed: 'falló',
  },
  inventory: {
    title: 'Inventario — salud',
    subtitle: 'Cuánto vale tu inventario, qué tan bien trabaja (GMROI) y qué partes están sin venta o bajo mínimo.',
    tabs: {
      skus: 'Por parte',
      lines: 'Por línea',
      stores: 'Por tienda',
      // v2.27 — top-level tabs (Salud / GMROI / Velocidad). Nested below the
      // existing per-view tabs.
      health: 'Salud',
      gmroi: 'GMROI',
      velocity: 'Velocidad',
      transfers: 'Traspasos',
      count: 'Conteo físico',
      minmax: 'Mín/máx',
    },
    gmroiTitle: 'GMROI por tienda',
    gmroiSubtitle: 'Comparación de GMROI por tienda contra el promedio de la cadena.',
    gmroiNoCost: 'Esta vista requiere visibilidad de costo (rol Gerente o Dueño).',
    gmroiCols: {
      store:    'Tienda',
      invCost:  'Inventario',
      margin:   'Margen 90d',
      gmroi:    'GMROI',
      skuCount: 'SKUs',
      aCount:   'Clase A',
    },
    velocityTitle: 'Velocidad ABC',
    velocitySubtitle: 'Partes ordenadas por el margen que generan en 90 días. El % acumulado muestra cuántas partes concentran la ganancia — y cuáles son la "cola larga".',
    velocityCols: {
      part:   'Parte',
      pdesc:  'Descripción',
      onHand: 'Existencia',
      units:  'Vendidos 90d',
      margin: 'Margen 90d',
      share:  '% del margen',
      cum:    '% acumulado',
      abc:    'Clase',
    },
    kpi: {
      chainGmroi: 'GMROI cadena',
      invCost: 'Inventario al costo',
      dead: 'Sin venta 365d',
      low: 'Bajo mínimo',
      aClass: 'SKUs A',
    },
    filter: {
      abc: 'ABC',
      abcAll: 'Todos',
      dead: 'Solo bajo mínimo o sin venta 365d',
    },
    cols: {
      part: 'Parte',
      pdesc: 'Descripción',
      sid: 'Tienda',
      onHand: 'Existencia',
      invCost: 'Inv. al costo',
      margin: 'Margen 90d',
      units: 'Unidades 90d',
      gmroi: 'GMROI',
      abc: 'ABC',
      kind: 'Estado',
      line: 'Línea',
      sku: 'SKUs',
      dead: 'Sin venta 365d',
      low: 'Bajo mínimo',
      abcCounts: 'A/B/C',
    },
    kindBadge: {
      dead: 'Sin venta',
      low: 'Bajo mínimo',
      normal: 'OK',
    },
    /* Tooltip shown next to GMROI labels. Plain-Spanish explanation + worked
     * example + interpretation guide so buyers and store managers don't need
     * to look up the term. ** wraps render bold via InfoTooltip. */
    gmroiHelp:
      '**¿Qué es GMROI?**\n' +
      'Mide cuántos pesos de margen ganas por cada peso que tienes invertido en inventario.\n' +
      '\n' +
      '**Cálculo:** Margen bruto de 90 días ÷ Inventario al costo (actual)\n' +
      '\n' +
      '**Ejemplo:** Una pieza que te cuesta $100 y vendes 3 veces en 90 días con $30 de margen cada vez genera $90 de margen. GMROI = $90 / $100 = 90% (0.90).\n' +
      '\n' +
      '**Interpretación:**\n' +
      '• Mayor a 200%: excelente — el inventario trabaja mucho\n' +
      '• 50%–200%: saludable\n' +
      '• Menor a 50%: bajo — sobra inventario o el margen es pobre',
    notReady: 'La información de inventario se está preparando. Vuelve a intentar en unos minutos.',
    empty: 'Sin datos.',
    trend: {
      title: 'Tendencia',
      totalCost: 'Inventario al costo',
      deadCost: 'Sin venta 365d',
      lowCount: 'Bajo mínimo',
      counted90: '% contado (90d)',
      counted90Hint: 'SKUs con conteo físico en los últimos 90 días',
      staleHint: 'SKUs sin contar en 365+ días',
      noRecentCounts: 'Sin conteo físico reciente. Considera implementar conteos cíclicos.',
    },
    // v2.57 — per-line drill-down modal (click a row in "Por línea").
    lineDetail: {
      totalParts: 'Partes en catálogo',
      totalValue: 'Valor en existencia',
      suppliers: 'Proveedores',
      noSuppliers: 'Sin proveedores ligados a esta línea.',
      pcodes: 'Códigos de producto',
      noPcodes: 'Sin códigos de producto en esta línea.',
      cols: {
        code: 'Código',
        desc: 'Descripción',
        parts: 'Partes',
        value: 'Valor',
      },
    },
  },
  vendors: {
    title: 'Proveedores — desempeño 180 días',
    subtitle: 'Qué tan bien te surte cada proveedor, calculado sobre las órdenes de compra de los últimos 180 días.',
    tabs: {
      byVendor: 'Por proveedor',
      byLine: 'Por línea',
    },
    kpi: {
      activeVendors: 'Proveedores activos',
      lineCount: 'Líneas surtidas',
      chainFillRate: 'Surtido cadena',
      chainLeadTime: 'Entrega promedio (días)',
    },
    cols: {
      vendor: 'Proveedor',
      poCount: 'Órdenes',
      ordered: 'Ordenado',
      received: 'Recibido',
      fillRate: 'Surtido %',
      leadTime: 'Entrega (días)',
      costTrend: 'Tendencia costo %',
      lineCount: 'Líneas',
      line: 'Línea',
      altLine: 'Alt',
      xline: 'Xref',
      lev: 'Nivel',
      disc: 'Desc. %',
      curr: 'Moneda',
      supplierCount: 'Proveedores',
      spend180d: 'Gasto 180d',
      ponum: 'OC',
      podate: 'Fecha',
      lines: 'Líneas',
      status: 'Estado',
    },
    modal: {
      tabPOs: 'OC recientes',
      tabCards: 'Tarjetas de línea',
      summary: 'Resumen 180d',
    },
    emptyVendors: 'Sin proveedores con compras en los últimos 180 días.',
    emptyLineCards: 'Sin tarjetas de línea registradas.',
    emptyPOs: 'Sin OC recientes.',
    notReady: 'La información de proveedores se está preparando. Vuelve a intentar en unos minutos.',
  },
  salespeople: {
    title: 'Vendedores',
    subtitle: 'Desempeño por vendedor y por mostrador.',
    attr: {
      slid: 'Vendedor',
      ctrmn: 'Mostrador',
    },
    win: {
      mtd: 'Mes actual',
      d30: 'Últimos 30 días',
      d7: 'Últimos 7 días',
    },
    view: {
      resumen: 'Resumen',
      porLinea: 'Por línea',
      perdidas: 'Ventas perdidas',
    },
    lost: {
      title: 'Ventas perdidas por línea',
      valueChart: 'Valor perdido por línea',
      countChart: 'Ventas perdidas por línea (conteo)',
      total: 'TOTAL',
      empty: 'Sin ventas perdidas en el periodo.',
      cols: {
        line: 'Línea',
        desc: 'Descripción',
        count: 'Conteo',
        units: 'Unidades',
        value: 'Valor perdido',
      },
    },
    byLine: {
      cols: {
        line: 'Línea',
        units: 'Unidades',
        revenue: 'Venta',
        margin: 'Margen',
      },
      total: 'Total',
      lineCount: 'líneas',
      empty: 'Sin ventas en el periodo.',
    },
    cols: {
      name: 'Nombre',
      tickets: 'Tickets',
      revenue: 'Ingreso',
      margin: 'Margen',
      avgTicket: 'Ticket prom.',
      returns: 'Devoluciones',
      netMargin: 'Margen neto',
    },
    unassigned: 'Sin vendedor',
    empty: 'Sin datos en el rango seleccionado.',
    modal: {
      title: 'Top 10 partes',
      seeTickets: 'Ver tickets de este vendedor',
      empty: 'Sin partes vendidas en el rango.',
    },
    personFilter: { label: 'Persona', all: 'Todos' },
    charts: { byPerson: 'Ingreso por persona', byLine: 'Ingreso por línea' },
    export: { button: 'Descargar CSV', pdfButton: 'Descargar PDF', includeLines: 'Incluir subtotales por línea', total: 'TOTAL', printTitle: 'Comisiones' },
  },
  customer: {
    title: 'Cuenta',
    tabSummary: 'Resumen',
    notFound: 'Cuenta no encontrada.',
    back: '← Volver',
    header: {
      anum: 'Cuenta',
      phone: 'Teléfono',
      address: 'Dirección',
      creditLimit: 'Límite de crédito',
      taxId: 'RFC',
      status: {
        active: 'Activa',
        suspended: 'Suspendida',
        over_limit: 'Sobre límite',
      },
    },
    ar: {
      total: 'Saldo total',
      b0_30: '0-30',
      b31_60: '31-60',
      b61_90: '61-90',
      b90p: '90+',
    },
    dso: {
      label: 'DSO (días)',
      hint: 'Días promedio de cobro = saldo × 365 / ingresos 365d',
      na: 'N/A',
    },
    openInvoices: {
      title: 'Facturas abiertas',
      empty: 'Sin facturas abiertas.',
      cols: {
        idate: 'Fecha',
        inum: 'Factura',
        total: 'Total',
        balance: 'Saldo',
        daysOld: 'Días',
      },
    },
    recentTickets: {
      title: 'Tickets recientes',
      empty: 'Sin tickets recientes.',
      cols: {
        idate: 'Fecha',
        tnum: 'Ticket',
        type: 'Tipo',
        total: 'Total',
        balance: 'Saldo',
      },
    },
    recentPayments: {
      title: 'Pagos recientes',
      empty: 'Sin pagos recientes.',
      cols: {
        tdate: 'Fecha',
        amount: 'Monto',
        appliedTo: 'Aplicado a',
      },
    },
    topParts: {
      title: 'Partes más compradas (90 días)',
      empty: 'Sin partes en los últimos 90 días.',
      cols: {
        part: 'Parte',
        pdesc: 'Descripción',
        qty: 'Cant.',
        revenue: 'Ingreso',
        margin: 'Margen',
      },
    },
    revenueTrend: {
      title: 'Tendencia de ingresos (12 meses)',
      empty: 'Sin actividad en 12 meses.',
    },
  },
  minmaxPage: {
    title: 'Recalcular mín/máx por lote',
    store: 'Tienda',
    lines: 'Líneas (separadas por coma, vacío = todas)',
    running: 'Calculando…',
    results: 'Propuestas',
    proposalsOf: 'propuestas de',
    partsReviewed: 'partes revisadas',
    skipped: 'Omitidas',
    skip: {
      noHistory: 'sin historia',
      manual: 'marcadas manuales',
      edate: 'creadas después del corte',
      stock: 'por tipo de surtido',
      filters: 'por filtros',
    },
    capped: 'Se alcanzó el límite de filas — refine los filtros para ver el resto.',
    empty: 'Sin propuestas: los niveles actuales ya coinciden con el cálculo.',
    selectAll: 'Seleccionar todo',
    selectNone: 'Quitar selección',
    exportCsv: 'Exportar CSV',
    applyN: 'Aplicar cambios:',
    applied: 'Niveles aplicados',
    appliedWithProblems: 'Aplicado con problemas',
    cols: {
      store: 'Tienda',
      line: 'Línea',
      part: 'Parte',
      history: 'Historia',
      curMin: 'Mín actual',
      newMin: 'Mín nuevo',
      curMax: 'Máx actual',
      newMax: 'Máx nuevo',
      include: 'Incluir',
    },
  },
  // JCD-59 — copy for the app-wide drill-down modals (inv / tkt / cuenta /
  // orden / tienda). Shared by DrilldownHost and the two new modals.
  drilldown: {
    back: 'Regresar',
    close: 'Cerrar',
    // Inventory record
    invTitle: 'Registro de inventario',
    thisStore: 'Esta tienda',
    onHand: 'Existencia',
    min: 'Mínimo',
    max: 'Máximo',
    bin: 'Ubicación',
    phydate: 'Último inventario físico',
    edate: 'Última actualización',
    prices: 'Precios',
    price1: 'Precio 1',
    price2: 'Precio 2',
    price3: 'Precio 3',
    listPrice: 'Precio de lista',
    costs: 'Costos',
    costMxn: 'Costo MXN',
    costUsd: 'Costo USD',
    factory: 'Fábrica / catálogo',
    factoryList: 'Lista de fábrica',
    factoryPrice1: 'Precio 1 de fábrica',
    factoryPrice2: 'Precio 2 de fábrica',
    factoryPrice3: 'Precio 3 de fábrica',
    factoryCostMxn: 'Costo de fábrica MXN',
    factoryCostUsd: 'Costo de fábrica USD',
    factoryCoreCost: 'Costo de core',
    crossRefs: 'Equivalencias',
    substitute: 'Sustituto',
    supersededFrom: 'Reemplaza a',
    alt1: 'Alterno 1',
    alt2: 'Alterno 2',
    partComp: 'Parte complementaria',
    codes: 'Códigos',
    fullPart: 'Abrir ficha de la parte',
    notStocked: 'Esta parte no tiene registro de inventario en esta tienda.',
    never: 'Nunca',
    // Account
    accountTitle: 'Cuenta',
    fullCustomer: 'Abrir ficha completa',
    accountNotFound: 'Cuenta no encontrada.',
  },
  part: {
    title: 'Parte',
    notFound: 'Parte no encontrada.',
    back: '← Volver',
    tabs: {
      summary: 'Resumen',
      rastreo: 'Rastreo',
    },
    rastreo: {
      title: 'Rastreo de inventario',
      subtitle: 'Movimientos en el rango + comparación contra el snapshot inicial cuando esté disponible.',
      empty: 'Sin movimientos en el rango.',
      kpi: {
        receipts:  'Recibido',
        poReturns: 'Devuelto a proveedor',
        sales:     'Vendido',
        custReturns: 'Devuelto por cliente',
        net:       'Neto',
      },
      perStore: {
        title:    'Por tienda',
        sid:      'Tienda',
        startInstk: 'Inicio',
        currentInstk: 'Actual',
        phydate:  'Último conteo',
        net:      'Neto en rango',
        expected: 'Esperado',
        discrepancy: 'Discrepancia',
        noAnchor: 'Sin snapshot del día inicial (se necesita ≥1 día desde v2.7).',
      },
      events: {
        title:    'Eventos',
        date:     'Fecha',
        kind:     'Tipo',
        qty:      'Cant.',
        sid:      'Tienda',
        ref:      'Referencia',
        price:    'Precio/Costo unit.',
        counterparty: 'Contraparte',
      },
      kinds: {
        receipt:         'Recepción',
        po_return:       'Devolución a proveedor',
        sale:            'Venta',
        customer_return: 'Devolución de cliente',
      },
    },
    header: {
      line: 'Línea',
      part: 'Parte',
      pdesc: 'Descripción',
      addlDesc: 'Descripción adicional',
      type: 'Tipo',
      uom: 'U/M',
      sustituyePor: 'Sustituido por',
      altPart: 'Alternativo',
    },
    inv: {
      title: 'Inventario por tienda',
      cols: {
        store: 'Tienda',
        onHand: 'Existencia',
        min: 'Mín',
        max: 'Máx',
        bin: 'Ubicación',
        plist: 'Lista',
        price1: 'Precio 1',
        price2: 'Precio 2',
        price3: 'Precio 3',
        cost1: 'Costo MXN',
        cost2: 'Costo Dlls',
        phydate: 'Último conteo',
      },
    },
    edit: {
      title: 'Editar inventario',
      open: 'Editar',
      close: 'Cerrar',
      loading: 'Cargando registro…',
      save: 'Guardar cambios',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
      saved: 'Cambios guardados.',
      noChanges: 'No hay cambios que guardar.',
      notStocked: 'Esta parte no tiene existencia registrada en esta tienda, así que no hay nada que editar aquí. Cambie de tienda para editarla.',
      confirmTitle: 'Confirmar cambios',
      onHandNote: 'La existencia se ajusta desde Discrepancias → Ajustar existencia.',
      historyNote: 'Los datos de historial no son editables.',
      errOrdpack: 'El empaque de compra debe ser múltiplo del empaque.',
      errPositive: 'debe ser mayor o igual a cero.',
      errAtLeastOne: 'debe ser mayor o igual a uno.',
      groups: {
        stocking: 'Niveles y ubicación',
        packaging: 'Empaque',
        flags: 'Banderas',
        operational: 'Operación',
        prices: 'Precios',
        costs: 'Costos',
      },
      f: {
        min1: 'Mín 1',
        max1: 'Máx 1',
        min2: 'Mín 2',
        max2: 'Máx 2',
        bin_min: 'Mín de ubicación',
        bin_max: 'Máx de ubicación',
        bin: 'Ubicación',
        altbin: 'Ubicación alterna',
        class: 'Clase',
        taxst: 'Impuesto',
        pack: 'Empaque',
        ordpack: 'Empaque de compra',
        u_of_ms: 'Unidad',
        sellqty: 'Cantidad de venta',
        break_pack: 'Vender solo por empaque',
        ckstk: 'Revisar existencia',
        ord_flag: 'Surtir por OC automática',
        manupd_flag: 'Excluir de actualizaciones automáticas',
        master_inst: 'Parte de instalador maestro',
        bkoqty: 'Cantidad pendiente',
        infrght1: 'Flete 1',
        infrght2: 'Flete 2',
        plist: 'Precio de lista',
        price1: 'Precio 1',
        price2: 'Precio 2',
        price3: 'Precio 3',
        pcore: 'Precio de core',
        cost1: 'Costo A',
        cost2: 'Costo B',
        costave: 'Costo promedio',
        pccost: 'Costo de core',
      },
      readOnly: {
        instk: 'Existencia',
        commitqty: 'Comprometido',
        onord: 'En pedido',
        updat: 'Actualizado',
        pricedate: 'Fecha de precio',
      },
    },
    minmax: {
      title: 'Recalcular mín/máx',
      calc: 'Calcular',
      apply: 'Aplicar',
      applied: 'Niveles aplicados.',
      noChange: 'Sin cambios: los niveles actuales ya coinciden con el cálculo.',
      filtered: 'Esta parte quedó fuera de los filtros del cálculo.',
      histUsed: 'Historia usada',
      proposal: 'Propuesta',
      curArrow: 'actual → nuevo',
      params: {
        season: 'Temporada',
        periods: 'Periodos de historia',
        from: 'desde',
        to: 'hasta',
        weeks: 'Semanas en el rango',
        days: 'Días de venta por semana',
        minDays: 'Días de stock mínimo',
        maxDays: 'Días de stock máximo',
        minRound: 'Redondeo de mínimo',
        maxRound: 'Redondeo de máximo',
        packRound: 'Redondeo a empaque',
        lowestMin: 'Mínimo más bajo',
        lowestMinHint: 'Número de piezas, o «s» / «3s» para múltiplos de la cantidad de venta.',
        multSell: 'Múltiplo de cantidad de venta',
        maxOne: 'Subir máximo a 1 si la venta llega a',
        pctThreshold: 'Reportar sólo cambios de al menos (%)',
        allStores: 'Sumar historia de todas las tiendas',
      },
      round: {
        U: 'Arriba',
        D: 'Abajo',
        O: 'Al más cercano',
      },
      pack: {
        N: 'No redondear',
        U: 'Empaque, arriba',
        D: 'Empaque, abajo',
        O: 'Empaque de compra, abajo',
        OU: 'Empaque de compra, arriba',
      },
      err: {
        weeks: 'Las semanas deben ser mayores que cero.',
        days: 'Los días de venta deben ser mayores que cero.',
        max_days: 'Los días de stock máximo deben ser mayores que cero.',
        min_days: 'Los días de stock mínimo no pueden ser negativos.',
        per_start: 'El periodo inicial debe estar entre 0 y 26.',
        per_end: 'El periodo final debe estar entre 0 y 26.',
        pct_threshold: 'El umbral no puede ser negativo.',
        lowestMin: 'Mínimo más bajo inválido: use un número, o «s» / «3s».',
      },
    },
    audit: {
      title: 'Historial de cambios',
      empty: 'Sin cambios registrados para esta parte.',
      cols: {
        at: 'Fecha',
        user: 'Usuario',
        field: 'Campo',
        old: 'Antes',
        new: 'Después',
        result: 'Resultado',
      },
    },
    movement: {
      title: 'Movimientos (90 días)',
      empty: 'Sin movimientos en los últimos 90 días.',
      cols: {
        tdate: 'Fecha',
        event: 'Evento',
        qty: 'Cant.',
        store: 'Tienda',
        ref: 'Ref',
        unitPrice: 'Precio unit.',
        counterparty: 'Contraparte',
      },
      types: {
        sale: 'Venta',
        receipt: 'Compra',
        transfer_in: 'Traspaso (entra)',
        transfer_out: 'Traspaso (sale)',
        return: 'Devolución',
      },
    },
  },
  archives: {
    title: 'Archivos',
    subtitle: 'Respaldo histórico diario de ventas e inventario, comprimido. Se conservan 5 años por requisito del SAT.',
    lastRun: 'Última ejecución',
    never: 'Nunca',
    ftpBackedUp: 'Respaldado en FTP',
    ftpFailed: 'Respaldo FTP falló',
    download: 'Descargar',
    empty: 'Sin archivos en este flujo todavía.',
    cols: {
      filename: 'Archivo',
      size: 'Tamaño',
      archivedAt: 'Archivado',
    },
  },
  // Friendly field labels for every column the daemons return. Keyed by the
  // canonical name the daemon emits — keep these in sync when new sources or
  // columns are added. Unknown keys fall back to the raw name (see
  // fieldLabel()), so adding a column without updating this table only loses
  // pretty-printing, not function.
  //
  // Source coverage (last audit: v2.12):
  //   sales      → sid, tnum, anum, idate, itime_secs, slid, slid_name,
  //                store_name, subt_mxn, tax_mxn, total_mxn, type, type_label,
  //                paid_mxn, balance_mxn, inum
  //   parts      → line, part, pdesc, sid, on_hand, min, last_sold, kind
  //   ar         → anum, name, total_mxn, aging
  //   sps        → slid, name
  //   facturasr  → sid, anum, name, rfc, inum, tnum, confnum, idate, type,
  //                type_label, subt_total, iva, total, cost, formapago,
  //                ctapago, slid, fecha_timbrado, factura_relacionada
  //   ticket     → line items: line, part, pdesc, qty_sold, sell_mxn,
  //                pcost_mxn, extended_mxn; payments: tdate, amount_mxn
  fields: {
    // ids + names
    sid:        'Tienda',
    store_name: 'Sucursal',
    tnum:       'Ticket',
    anum:       'Cuenta',
    name:       'Nombre',
    rfc:        'RFC',
    inum:       'Factura',
    confnum:    'UUID fiscal',
    slid:       'Vendedor',
    slid_name:  'Nombre vendedor',
    line:       'Línea',
    part:       'Parte',
    pdesc:      'Descripción',
    // dates + times
    idate:        'Fecha',
    itime_secs:   'Hora',
    last_sold:    'Última venta',
    tdate:        'Fecha pago',
    fecha_timbrado: 'Fecha timbrado',
    // amounts (sales)
    subt_mxn:    'Subtotal MXN',
    tax_mxn:     'IVA MXN',
    total_mxn:   'Total MXN',
    paid_mxn:    'Pagado MXN',
    balance_mxn: 'Saldo MXN',
    sell_mxn:    'Precio MXN',
    pcost_mxn:   'Costo unitario MXN',
    extended_mxn:'Extendido MXN',
    amount_mxn:  'Monto MXN',
    // amounts (facturasr)
    subt_total:  'Subtotal',
    iva:         'IVA',
    total:       'Total',
    cost:        'Costo',
    // misc
    qty_sold:    'Cantidad',
    type:        'Tipo (código)',
    type_label:  'Tipo',
    formapago:   'Forma de pago',
    ctapago:     'Cuenta de pago',
    kind:        'Estado',
    on_hand:     'Existencia',
    min:         'Mínimo',
    aging:       'Antigüedad',
    factura_relacionada: 'Factura relacionada',
    // inventory (partf + inv wide source)
    min_stock:           'Mínimo',
    bin:                 'Bin',
    phydate:             'Último inventario físico',
    cost_mxn:            'Costo MXN',
    cost_usd:            'Costo USD',
    price1_mxn:          'Precio 1',
    price2_mxn:          'Precio 2',
    price3_mxn:          'Precio 3',
    store_list_price:    'Precio lista (tienda)',
    factory_list_price:  'Precio lista (fábrica)',
    factory_price1:      'Precio fábrica 1',
    factory_price2:      'Precio fábrica 2',
    factory_price3:      'Precio fábrica 3',
    factory_cost_mxn:    'Costo fábrica MXN',
    factory_cost_usd:    'Costo fábrica USD',
    factory_core_cost:   'Costo core fábrica',
    sub_line:            'Sustituido por (línea)',
    sub_part:            'Sustituido por (parte)',
    sub_from_line:       'Sustituye a (línea)',
    sub_from_part:       'Sustituye a (parte)',
    alt1_line:           'Alterno 1 (línea)',
    alt1_part:           'Alterno 1 (parte)',
    alt2_line:           'Alterno 2 (línea)',
    alt2_part:           'Alterno 2 (parte)',
    part_comp:           'Parte (comprimido)',
    codes:               'Códigos',
    // purchases source (v2.38)
    onum:           'OC#',
    sup_id:         'Proveedor (clave)',
    sup_name:       'Proveedor',
    cdate:          'Fecha OC',
    days_open:      'Días abierta',
    lines:          'Líneas',
    qty_ord:        'Cant. ordenada',
    qty_rcv:        'Cant. recibida',
    total_cost_mxn: 'Costo total MXN',
    last_recv_at:   'Última recepción',
    status:         'Estado',
    ext_mxn:        'Subtotal MXN', // sales-lines: sell × qty
    // month-end source (JCD-37) — sid/store_name already defined above
    group_code:        'Plaza',
    inv_cost_mxn:       'Costo inventario MXN',
    inv_snapshot_date:  'Fecha inventario',
    xfer_out_mxn:       'Traspasos salida MXN',
    xfer_in_mxn:        'Traspasos entrada MXN',
    purchases_mxn:      'Compras MXN',
    cogs_header_mxn:    'Costo de venta (sistema) MXN',
    cogs_lines_mxn:     'Costo de venta (líneas) MXN',
    sales_parts_mxn:    'Venta partes MXN',
    sales_sin_iva_mxn:  'Venta sin IVA MXN',
    labor_mxn:          'Mano de obra MXN',
    labor_jobs_mxn:     'Mano de obra taller MXN',
    tickets:            'Tickets',
    margin_pct:         'Margen %',
    // counter-lines source (JCD-58) — line/part/idate/tnum/pdesc already defined above
    ctrmn_id:      'Id mostrador',
    ctrmn_name:    'Mostrador',
    importe_mxn:   'Importe MXN',
    prclev:        'Nivel precio cuenta',
    cost1_mxn:     'Costo MXN',
    item_type:     'Tipo de partida',
    // agent-sales source (JCD-76) — sid/store_name/slid/slid_name/tickets already defined above
    venta_mxn:      'Venta sin IVA',
    costo_mxn:      'Costo',
    margen_mxn:     'Margen',
    margen_pct:     'Margen %',
    prev_venta_mxn: 'Venta periodo anterior',
    diff_mxn:       'Diferencia',
    diff_pct:       'Diferencia %',
    prev_from:      'Periodo anterior desde',
    prev_to:        'Periodo anterior hasta',
  } as Record<string, string>,
  tablero: {
    title: 'Mi tablero',
    subtitle: 'Tus gráficas y reportes favoritos en un solo lugar.',
    loading: 'Cargando…',
    singleStore: 'Una sola tienda: sin desglose por tienda.',
    widgetUnavailable: 'Widget no disponible.',
    reportWidget: 'Reporte',
    reportUnavailable: 'Este reporte ya no está disponible.',
    reportEmpty: 'Sin filas.',
    rows: 'filas',
    edit: {
      editButton:   'Editar',
      saveButton:   'Guardar',
      cancelButton: 'Cancelar',
      resetButton:  'Restablecer',
      resetConfirm: '¿Restablecer tu tablero al predeterminado? Se perderá tu personalización.',
      saveError:    'No se pudo guardar el tablero.',
      moveLeft:     'mover izquierda',
      moveRight:    'mover derecha',
      remove:       'quitar',
      span:         'Ancho',
      storeFilter:  'Tienda',
      allStores:    'Todas',
      from:         'Desde',
      to:           'Hasta',
      addWidget:        'Agregar widget',
      chartsSection:    'Gráficas',
      reportsSection:   'Tus reportes guardados',
      noReports:        'No tienes reportes guardados.',
      alreadyAdded:     'ya agregado',
      charts: {
        kpis:            'Indicadores (KPIs)',
        exceptions:      'Excepciones',
        'sales-period':  'Ventas por hora',
        'sales-by-store':'Ventas por tienda',
        'top-parts':     'Partes más vendidas',
        'top-customers': 'Mejores clientes',
        'low-stock':     'Bajo stock',
        'slow-movers':   'Lento movimiento',
      },
    },
  },
  reports: {
    title: 'Reportes',
    subtitle: 'Crea, guarda y ejecuta consultas sobre ventas, partes, cuentas y vendedores.',
    new: 'Nuevo reporte',
    requestReport: 'Solicitar un reporte',
    requestReportTitlePrefix: 'Solicitud de reporte: ',
    requestReportIntro: 'Describe el reporte que necesitas: qué columnas, con qué filtros o periodo, y para qué lo usarás. Lo revisaremos y te avisaremos con el número de ticket.',
    edit: 'Editar',
    duplicate: 'Duplicar',
    delete: 'Eliminar',
    builtin: 'Predefinido',
    confirmDelete: '¿Eliminar este reporte? Esta acción no se puede deshacer.',
    run: 'Ejecutar',
    runPreview: 'Vista previa',
    save: 'Guardar',
    cancel: 'Cancelar',
    downloadCsv: 'Descargar CSV',
    downloadPdf: 'Descargar PDF',
    empty: 'No hay reportes guardados todavía. Crea uno para empezar.',
    rowCount: 'filas',
    truncated: 'Resultado truncado a',
    truncatedHint: 'filas. Acota por tienda, línea o fechas para obtener el listado completo.',
    truncatedShort: 'truncado',
    field: {
      name: 'Nombre',
      description: 'Descripción',
      source: 'Origen de datos',
      filters: 'Filtros',
      columns: 'Columnas',
      sort: 'Orden',
      limit: 'Límite',
      shared: 'Visible para todo el equipo',
      createdBy: 'Creado por',
      updatedAt: 'Actualizado',
    },
    source: {
      sales: 'Ventas',
      parts: 'Partes',
      ar: 'Cuentas por cobrar',
      salespeople: 'Vendedores',
      facturasr: 'Facturas (auditoría)',
      inventory: 'Inventario (catálogo + existencias)',
      purchases: 'Compras (órdenes a proveedor)',
      'sales-lines': 'Ventas por parte (renglón a renglón)',
      'month-end': 'Cierre de mes por tienda',
      'counter-lines': 'Ventas de mostrador por línea (comisiones)',
      'agent-sales': 'Ventas por agente y sucursal (comisiones)',
    },
    dateTokenHelp: 'Acepta @today, @yesterday, @start_of_month, @end_of_month, @last_month_start, @last_month_end, @start_of_year, @today_minus_N o fecha literal YYYY-MM-DD.',
    runError: 'No se pudo ejecutar el reporte',
    noRows: 'Sin resultados con estos filtros.',
    async: 'Ejecutar en segundo plano',
    asyncShort: 'Segundo plano',
    asyncHint: 'Para reportes grandes: corre sin bloquear la pantalla y lo descargas cuando esté listo.',
    asyncSubmitted: 'Enviado a segundo plano — aparecerá abajo en Trabajos.',
    jobsTitle: 'Trabajos en segundo plano',
    jobsEmpty: 'Sin trabajos. Usa "Ejecutar en segundo plano" en cualquier reporte.',
    jobStatus: {
      queued: 'En cola',
      running: 'Ejecutando…',
      done: 'Listo',
      failed: 'Falló',
    },
    jobCols: {
      name: 'Reporte',
      status: 'Estado',
      rows: 'Filas',
      created: 'Enviado',
      actions: '',
    },
  },
  payments: {
    title: 'Aplicar pago',
    fields: {
      amount: 'Monto',
      cashCode: 'Forma de cobro',
      cashCodePlaceholder: 'Selecciona forma de cobro…',
      reference: 'Referencia / cheque',
      tdate: 'Fecha',
    },
    autoFill: 'Auto (FIFO)',
    invoiceCols: {
      inum: 'Factura',
      ddate: 'Vence',
      due: 'Saldo',
      apply: 'Aplicar',
    },
    aplicado: 'Aplicado',
    saldoAFavor: 'Saldo a favor',
    apply: 'Aplicar pago',
    finalize: 'Finalizar / timbrar',
    undo: 'Deshacer',
    finalized: 'Timbrado',
    confnum: 'UUID fiscal',
    pendingTitle: 'Pago creado — confirma o deshaz',
    pendingApplied: 'Aplicado a facturas',
    pendingOnAccount: 'A cuenta general',
    finalizing: 'Timbrando…',
    finalizeError: 'Error al timbrar',
    voiding: 'Deshaciendo…',
    errors: {
      amountRequired: 'Ingresa un monto mayor a cero.',
      cashCodeRequired: 'Selecciona una forma de cobro.',
      overApplied: 'La suma aplicada supera el monto del pago.',
      rowOver: 'La cantidad aplicada supera el saldo de la factura.',
      generic: 'No se pudo completar la operación.',
    },
    empty: 'Sin facturas abiertas — no hay qué aplicar.',
  },
  print: {
    button: 'Imprimir',
    generatedOn: 'Generado',
    printedBy: 'Impreso por',
  },
  discrepancias: {
    title: 'Discrepancias de inventario',
    subtitle: 'Ventas donde la existencia no se descontó como debía — detección de faltantes y errores de posteo.',
    tabs: {
      worklist: 'Discrepancias',
      recon: 'Reconciliación',
      commit: 'Comprometido',
      changelog: 'Movimientos de existencia',
    },
    filters: {
      store: 'Tienda',
      from: 'Desde',
      to: 'Hasta',
      cause: 'Causa',
      allCauses: 'Todas',
      date: 'Fecha',
      search: 'Buscar',
    },
    causes: {
      notDiscounted: 'No descontado',
      wrongAmount: 'Monto incorrecto',
      commitOnly: 'Solo compromiso',
    },
    cols: {
      date: 'Fecha/Hora',
      store: 'Tienda',
      ticket: 'Ticket',
      part: 'Línea/Parte',
      qty: 'Cant.',
      instkBefore: 'Exist. antes',
      instkAfter: 'Exist. después',
      expected: 'Esperado',
      commit: 'Commit',
      onord: 'En orden',
      cause: 'Causa',
      cashier: 'Capturista',
      seller: 'Vendedor',
      captured: 'Capturado',
    },
    empty: 'Sin discrepancias en el rango seleccionado.',
    rowsLabel: 'discrepancias',
    downloadPdf: 'Descargar PDF',
    reconHint: 'Ventas del día cuya línea de inventario no tiene registro de captura — el gancho POS no se disparó.',
    uncaptured: 'Sin captura',
    uncapturedCount: 'ventas sin captura de descuento',
    commitHint: 'Comprometido esperado (de remisiones/tickets abiertos) vs. el contador del sistema. Diferencia positiva = posible fantasma de existencias por sesión interrumpida.',
    commitEmpty: 'Sin diferencias de comprometido.',
    commitSearch: 'Revisar comprometido',
    commitCols: {
      part: 'Línea/Parte',
      desc: 'Descripción',
      store: 'Tienda',
      expected: 'Esperado',
      actual: 'Actual',
      drift: 'Diferencia',
      tickets: 'Remisiones abiertas',
    },
    commitCorregir: 'Corregir',
    commitConfirmTitle: 'Corregir remisión',
    commitConfirmBody: 'Marca esta remisión como NO comprometida para evitar el fantasma de existencias en un borrado futuro. No cambia la existencia física — confírmalo solo si la remisión realmente no descontó.',
    commitConfirmMulti: 'Esta parte tiene más de una remisión abierta — asegúrate de elegir la correcta (haz un conteo físico si hay duda).',
    commitConfirmOk: 'Corregir',
    commitConfirmCancel: 'Cancelar',
    changelogSubtitle: 'Bitácora de cambios de existencia capturada por el disparador de la base de datos — cada fila es el estado tras un cambio (after-snapshot) más el delta contra el snapshot anterior.',
    changelogFilters: {
      line: 'Línea',
      part: 'Parte',
    },
    changelogCols: {
      store: 'Tienda',
      line: 'Línea',
      part: 'Parte',
      instk: 'Existencia',
      commitqty: 'Comprometido',
      delta: 'Delta',
      userid: 'Usuario',
      date: 'Fecha',
      time: 'Hora',
    },
    changelogEmpty: 'Sin movimientos de existencia en el rango seleccionado.',
    changelogRowsLabel: 'movimientos',
    // Task 11 ("Discrepancias: Detección" plan) — "Detectadas" tab: reconciled
    // discrepancy residuals from GET /api/discrepancies (sold vs. actually
    // decremented, already resolved to a cause + an attribution).
    detectadasTab: 'Detectadas',
    detectadasHint: 'Compara lo vendido (facturado) contra lo realmente descontado de existencia — el residual es lo que aún no cuadra tras la reconciliación automática.',
    colVendido: 'Vendido',
    colMovido: 'Movido',
    colResidual: 'Residual',
    colOrigen: 'Origen',
    origenPos: 'Falla POS',
    origenManual: 'Ajuste manual',
    // Task 7 ("Discrepancias: Resolución" plan, #209 Half B) — native-grade
    // stock adjustment: per-row "Ajustar" on Detectadas, a standalone
    // "Ajuste de existencia" panel, and the owner-only "Ajustes de
    // existencia" transparency log (GET /api/stock-adjustments).
    ajusteTab: 'Ajustes',
    ajustar: 'Ajustar',
    ajusteTitle: 'Ajuste de existencia',
    ajusteHint: 'Corrige la existencia de una parte a su valor real. Queda registrado de forma permanente — no hay reversa automática, confirma el conteo antes de aplicar.',
    ajusteStore: 'Tienda',
    ajusteLine: 'Línea',
    ajustePart: 'Parte',
    ajusteNewQty: 'Nueva existencia',
    ajusteReason: 'Motivo',
    ajusteReasonNone: 'Sin motivo',
    ajusteConfirmTitle: 'Confirmar ajuste de existencia',
    ajusteConfirmBody: 'Esta acción escribe directamente la existencia y queda registrada de forma permanente. No afecta costo, comprometido ni contabilidad.',
    ajusteConfirmOk: 'Aplicar ajuste',
    ajusteConfirmCancel: 'Cancelar',
    ajusteResidualHint: 'La cantidad sugerida deja en cero el residual detectado — ajústala si el conteo físico real es distinto.',
    ajustesLogTitle: 'Ajustes de existencia',
    colAnterior: 'Anterior',
    colNuevo: 'Nuevo',
    colWho: 'Quién',
    colWhen: 'Cuándo',
    colMotivo: 'Motivo',
    ajusteSuccess: 'Ajuste aplicado correctamente.',
  },
  caja: {
    title: 'Corte de Caja',
    views: {
      method:  'Por método',
      day:     'Por día',
      cashier: 'Por cajero',
    },
    kpi: {
      total:   'Total recaudado',
      cash:    'Efectivo',
      other:   'Otros métodos',
      tickets: 'Tickets',
      avg:     'Ticket promedio',
    },
    cols: {
      method:  'Método',
      tickets: '# Tickets',
      amount:  'Monto',
      pct:     '% del total',
      date:    'Fecha',
      total:   'Total',
      cashier: 'Cajero',
      folio:   'Folio',
      client:  'Cliente',
    },
    downloadCsv: 'Descargar CSV',
    downloadPdf: 'Descargar PDF',
    empty:       'Sin movimientos en el periodo',
    drillTitle:  'Tickets',
    sesiones: {
      tab:           'Sesiones de caja',
      estado:        'Estado',
      abrir:         'Abrir caja',
      retiro:        'Retiro / Ingreso',
      cerrarContar:  'Cerrar y contar',
      conciliar:     'Conciliar y completar',
      drawer:        'Caja',
      openBy:        'Abierta por',
      since:         'Desde',
      float:         'Fondo de apertura',
      current:       'Saldo actual',
      denom:         'Denominación',
      count:         'Cantidad',
      subtotal:      'Subtotal',
      total:         'Total',
      dropAmount:    'Monto',
      dropKind:      'Tipo',
      drop:          'Retiro (salida)',
      add:           'Ingreso (entrada)',
      tender:        'Forma de pago',
      memo:          'Nota',
      dropBtn:       'Registrar movimiento',
      blindCount:    'Conteo a ciegas',
      counted:       'Contado',
      expected:      'Esperado',
      overShort:     'Sobrante / Faltante',
      adjust:        'Ajuste',
      openBtn:       'Abrir caja',
      closeBtn:      'Cerrar y contar',
      completeBtn:   'Conciliar y completar',
      corte:         'Corte de caja',
      printCorte:    'Imprimir corte',
      noOpen:        'No hay cajas abiertas',
      pickDrawer:    'Seleccione una caja',
      registerStops: 'Al cerrar, la caja deja de vender hasta abrir una nueva sesión.',
      readonly:      'Escrituras deshabilitadas — solo lectura.',
      opened:        'Caja abierta',
      dropped:       'Movimiento registrado',
      closed:        'Caja cerrada / contada',
      completed:     'Sesión completada',
      sessionNum:    'Sesión',
    },
  },
  movil: {
    title: 'Resumen por tienda',
    windows: { today: 'Hoy', month: 'Mes', week: '7 días' },
    kpi: { total: 'Total facturado', profit: 'Utilidad', margin: 'Margen', tickets: 'Tickets' },
    seg: { parts: 'Refacciones', core: 'Núcleo', labor: 'Mano de obra', freight: 'Flete', tax: 'Impuesto', other: 'Otros' },
    byStore: 'Por tienda',
    groups: 'Grupos',
    sinGrupo: 'Sin grupo',
    barHint: 'Toca o pasa una barra para ver el desglose',
    empty: 'Sin ventas en el periodo',
    fullView: 'Vista completa',
    simple: 'Simple',
    detailed: 'Detallado',
    groupHint: 'Toca un grupo para ver sus tiendas',
    groupStores: 'Tiendas del grupo',
  },
  anticipos: {
    title: 'Anticipos',
    subtitle: 'Registrar anticipos (saldo a favor) del cliente',
    form: {
      customer: 'Cliente (cuenta)',
      amount: 'Monto',
      method: 'Método de pago',
      methodPlaceholder: 'Selecciona método…',
      reference: 'Referencia',
      submit: 'Registrar anticipo',
    },
    cols: {
      folio: 'Folio',
      customer: 'Cliente',
      amount: 'Monto',
      method: 'Método',
      reference: 'Referencia',
      actions: '',
    },
    reverse: 'Reversar',
    reverseConfirm: '¿Reversar este anticipo?',
    recorded: 'Anticipo registrado',
    empty: 'Sin anticipos en esta sesión',
    disabled: 'La escritura a la base de datos no está habilitada.',
    errors: {
      generic: 'No se pudo completar la operación.',
    },
  },
  conteo: {
    title: 'Conteo físico',
    subtitle: 'Cuenta el inventario físico contra lo que el sistema espera, por línea, clase o tienda completa.',
    newSession: 'Nuevo conteo',
    back: '← Volver a conteos',
    filters: {
      status: 'Estado',
      statusAll: 'Todos',
      store: 'Tienda',
      storeAll: 'Todas las tiendas',
    },
    form: {
      name: 'Nombre',
      store: 'Tienda',
      scopeType: 'Alcance',
      scopeLine: 'Línea',
      scopeClass: 'Clase',
      scopeFrom: 'Desde',
      scopeTo: 'Hasta',
      classFilter: 'Clase',
      blind: 'Conteo ciego (sin ver existencia esperada)',
      postMode: 'Modo de ajuste',
      uncounted: 'Partes sin contar',
      submit: 'Congelar conteo',
      confirmLarge: 'Confirmar y continuar de todas formas',
      confirmLargeTitle: 'Alcance grande',
      cancel: 'Cancelar',
      scopeOptions: {
        line: 'Línea',
        bin: 'Bin / ubicación',
        supplier: 'Proveedor',
        all: 'Toda la tienda',
      },
      postModeOptions: {
        delta: 'Delta — solo aplica diferencias',
        overwrite: 'Sobrescribir — iguala existencia a lo contado',
      },
      uncountedOptions: {
        skip: 'Omitir — deja la existencia igual',
        zero: 'Poner en cero',
      },
    },
    cols: {
      name: 'Nombre',
      store: 'Tienda',
      scope: 'Alcance',
      status: 'Estado',
      createdBy: 'Creado por',
      createdAt: 'Creado',
      actions: '',
    },
    status: {
      contando: 'Contando',
      revision: 'En revisión',
      posteado: 'Posteado',
      cancelado: 'Cancelado',
    },
    errors: {
      generic: 'No se pudo completar la operación.',
      scopeTooLarge: 'El alcance incluye {count} partes. Confirma para continuar de todas formas.',
    },
    empty: 'Sin conteos registrados todavía.',
    disabled: 'El módulo de conteo físico no está habilitado para esta empresa.',
    deleteConfirm: {
      title: 'Eliminar conteo',
      message: '¿Eliminar el conteo "{name}"? Esta acción no se puede deshacer.',
      confirm: 'Eliminar',
      cancel: 'Cancelar',
    },
    tabs: {
      capture: 'Capturar',
      variance: 'Variación',
      post: 'Postear',
    },
    progress: '{done} de {total} contadas',
    capture: {
      searchLabel: 'Buscar',
      searchPlaceholder: 'Parte, línea o bin…',
      colPart: 'Parte',
      colDesc: 'Descripción',
      colBin: 'Bin',
      colExpected: 'Esperado',
      colCounted: 'Contado',
      empty: 'Sin partidas en el alcance de este conteo.',
      noMatches: 'Sin resultados para tu búsqueda.',
    },
    csvImport: {
      title: 'Importar conteo por CSV',
      hint: 'Columnas: línea, parte, cantidad contada.',
      applied: '{n} línea(s) aplicada(s)',
      unmatched: 'No encontradas en el conteo',
      duplicate: 'Duplicadas en el archivo',
      nonNumeric: 'Cantidad inválida',
      cols: { row: 'Fila', part: 'Línea/Parte', reason: 'Motivo' },
    },
    variance: {
      kpi: {
        counted: 'Contadas',
        uncounted: 'Sin contar',
        withVariance: 'Con diferencia',
        netUnits: 'Neto unidades',
        grossValue: 'Valor bruto (dif.)',
        netValue: 'Valor neto',
      },
      filters: {
        all: 'Todos',
        short: 'Faltantes',
        over: 'Sobrantes',
        uncounted: 'Sin contar',
        variance: 'Con diferencia',
      },
      cols: {
        part: 'Parte',
        desc: 'Descripción',
        bin: 'Bin',
        expected: 'Esperado',
        counted: 'Contado',
        variance: 'Variación',
        value: 'Valor',
        drift: 'Drift',
      },
      exportPdf: 'Hoja de conteo (PDF)',
      printTitle: 'Hoja de conteo',
      empty: 'Sin partidas con este filtro.',
    },
    post: {
      title: 'Postear conteo',
      mode: 'Modo de ajuste',
      uncounted: 'Partes sin contar',
      button: 'Postear',
      restantes: 'Postear restantes',
      posteado: 'Este conteo ya fue posteado — los ajustes se aplicaron a la existencia.',
      statuses: {
        posted: 'Posteado',
        locked: 'Bloqueado',
        skipped: 'Omitido',
        error: 'Error',
      },
      writesOff: 'La escritura a la base de datos no está habilitada. No se pueden postear los ajustes de este conteo.',
      noPermission: 'No tienes permiso para postear este conteo.',
      cols: {
        part: 'Parte',
        status: 'Estado',
        change: 'Existencia',
      },
    },
  },
  recepcion: {
    navLabel: 'Recepción',
    title: 'Recepción de mercancía',
    subtitle: 'Escanea contra una orden de compra con uno o varios lectores de código de barras y concilia lo esperado contra lo escaneado.',
    newSession: 'Nueva recepción',
    back: '← Volver a recepciones',
    filters: {
      status: 'Estado',
      statusAll: 'Todos',
      store: 'Tienda',
      storeAll: 'Todas las tiendas',
    },
    cols: {
      onum: 'OC#',
      supplier: 'Proveedor',
      store: 'Tienda',
      status: 'Estado',
      createdBy: 'Creado por',
      createdAt: 'Creado',
      actions: '',
    },
    status: {
      abierto: 'Abierta',
      escaneando: 'Escaneando',
      revision: 'En revisión',
      recibido: 'Recibida',
      cancelado: 'Cancelada',
    },
    errors: {
      generic: 'No se pudo completar la operación.',
      poNotFound: 'No se encontró la orden de compra.',
    },
    empty: 'Sin recepciones registradas todavía.',
    disabled: 'El módulo de recepción no está habilitado para esta empresa.',
    deleteConfirm: {
      title: 'Eliminar recepción',
      message: '¿Eliminar la recepción de la OC #{onum}? Esta acción no se puede deshacer.',
      confirm: 'Eliminar',
      cancel: 'Cancelar',
    },
    new: {
      title: 'Nueva recepción',
      scanTab: 'Escanear etiqueta de OC',
      scanLabel: 'Código de etiqueta',
      scanPlaceholder: 'Escanea o escribe el código…',
      scanHint: 'Formato de etiqueta: O + tienda (2 díg.) + folio de OC.',
      scanInvalid: 'Código de etiqueta no válido.',
      submit: 'Abrir recepción',
      pickTab: 'Elegir una OC abierta',
      searchPlaceholder: 'Buscar OC, proveedor…',
      empty: 'Sin órdenes de compra abiertas.',
      cols: {
        onum: 'OC#',
        date: 'Fecha',
        supplier: 'Proveedor',
        store: 'Tienda',
        lines: 'Líneas',
      },
      open: 'Abrir',
    },
    scan: {
      device: 'Dispositivo',
      deviceHint: 'Identifica este lector — varios dispositivos pueden escanear la misma OC.',
      input: 'Escanea un código',
      inputPlaceholder: 'Escanea o escribe y presiona Enter…',
      inputHint: 'El campo vuelve a enfocarse automáticamente después de cada escaneo.',
      noReconocido: 'No reconocido',
      deviceTotal: 'Total en este dispositivo',
      unexpectedBadge: 'Inesperado',
      unexpectedTitle: 'Partes inesperadas — no están en la OC',
      keyedQty: {
        label: 'Agregar cantidad',
        placeholder: 'Ej. 50',
        apply: 'Aplicar',
      },
      linesTitle: 'Partidas de la OC',
      empty: 'Esta recepción no tiene partidas esperadas.',
      cols: {
        part: 'Parte',
        expected: 'Esperado',
        scanned: 'Escaneado',
      },
      reviewLink: 'Ir a revisión →',
      errors: {
        generic: 'No se pudo completar el escaneo.',
      },
    },
    review: {
      title: 'Revisión y conciliación',
      back: '← Volver al escaneo',
      kpi: {
        lines: 'Líneas',
        short: 'Faltantes',
        over: 'Sobrantes',
        unexpected: 'Inesperadas',
        netPacks: 'Neto (paquetes)',
        netValue: 'Valor neto',
      },
      filters: {
        all: 'Todos',
        short: 'Faltantes',
        over: 'Sobrantes',
        unexpected: 'Inesperados',
      },
      cols: {
        part: 'Parte',
        desc: 'Descripción',
        expected: 'Esperado',
        scanned: 'Escaneado',
        diff: 'Diferencia',
        value: 'Valor',
        class: 'Estado',
      },
      classes: {
        exact: 'Exacto',
        short: 'Faltante',
        over: 'Sobrante',
        unexpected: 'Inesperado',
      },
      byDevice: 'Por dispositivo',
      unexpectedTitle: 'Inesperado — no está en la OC',
      unexpectedEmpty: 'Sin partes inesperadas.',
      empty: 'Sin partidas con este filtro.',
      exportPdf: 'Descargar PDF',
      printTitle: 'Reporte de recepción — esperado vs. escaneado',
      post: {
        title: 'Postear recepción',
        button: 'Postear recepción',
        restantes: 'Recibir restantes',
        recibido: 'Esta recepción ya fue recibida — las partidas escaneadas se aplicaron a la existencia.',
        statuses: {
          posted: 'Recibido',
          locked: 'Bloqueado',
          error: 'Error',
          skipped: 'Omitido',
        },
        writesOff: 'La escritura a la base de datos no está habilitada. No se puede postear esta recepción.',
        noPermission: 'No tienes permiso para postear esta recepción.',
        cols: {
          part: 'Parte',
          status: 'Estado',
          received: 'Recibido',
        },
      },
    },
  },
  pacesetter: {
    title: 'Pacesetter',
    subtitle: 'Terminal del ERP clásico de Pacesetter (pantalla verde), directo desde el navegador.',
    status: {
      connecting: 'Conectando…',
      connected: 'Conectado',
      closed: 'Sesión terminada',
      error: 'Error de conexión',
    },
    reconnect: 'Reconectar',
    tab: {
      label: 'Terminal',
      new: 'Nueva terminal',
      close: 'Cerrar terminal',
    },
    keys: {
      pf1: 'PF1',
      pf2: 'PF2',
      pf3: 'PF3',
      pf4: 'PF4',
      f5: 'F5',
      f6: 'F6',
      f7: 'F7',
      f8: 'F8',
      f9: 'F9',
      f10: 'F10',
      f11: 'F11',
      f12: 'F12',
      f13: 'F13',
      f14: 'F14',
      esc: 'Esc',
      up: '↑',
      down: '↓',
      left: '←',
      right: '→',
      enter: 'Enter',
    },
    appearance: {
      title: 'Apariencia del terminal',
      subtitle: 'Se aplica a la sesión de todos los operadores que abran el terminal — no es por navegador ni por persona.',
      preset: 'Preset',
      presets: {
        green: 'Verde sobre negro',
        amber: 'Ámbar sobre negro',
        dec: 'Blanco sobre azul (DEC)',
        light: 'Claro',
        contrast: 'Alto contraste',
        app: 'Según la app',
        custom: 'Personalizado',
      },
      background: 'Fondo',
      foreground: 'Texto',
      cursor: 'Cursor',
      resetColors: 'Restablecer colores del preset',
      fontSize: 'Tamaño de letra',
      image: 'Imagen de fondo',
      imageUpload: 'Subir imagen',
      imageRemove: 'Quitar imagen',
      imageNone: 'Sin imagen de fondo.',
      dim: 'Opacidad',
      dimHint: 'Oscurece la imagen de fondo para que el texto siga siendo legible.',
      preview: 'Vista previa',
      save: 'Guardar',
      saved: 'Apariencia guardada.',
      errors: {
        imageTooLarge: 'La imagen supera el límite de 2 MB.',
        notImage: 'El archivo debe ser una imagen.',
        generic: 'No se pudo completar la operación.',
      },
    },
  },
  dvi: {
    title: 'Inspección', tab: 'Inspección',
    newInspection: 'Nueva inspección', finish: 'Finalizar inspección',
    share: 'Compartir con el cliente', copyLink: 'Copiar liga', shareHint: 'El cliente abre esta liga en su teléfono',
    status: { green: 'Bien', yellow: 'Atención', red: 'Urgente', na: '—' },
    note: 'Nota', recommend: 'Recomendar', estPrice: 'Precio est.', photo: 'Foto',
    recommendedTotal: 'Total recomendado', decision: { approve: 'Aprobar', decline: 'Rechazar', approved: 'Aprobado', declined: 'Rechazado' },
    report: { title: 'Inspección de su vehículo', tech: 'Inspeccionó', empty: 'Inspección no disponible' },
    empty: 'Sin inspecciones', pickWo: 'Seleccione una orden',
    // Standalone staff-reachable entry point (/inspecciones — see
    // pages/dvi/Inspecciones.tsx), separate from the Service cockpit's
    // "Inspección" tab (which reuses `title`/`empty`/`recommendedTotal`
    // above).
    nav: 'Inspecciones', startByWo: 'Nueva inspección por OT',
    store: 'Tienda', woNumber: 'No. de OT', start: 'Iniciar',
  },
  comms: {
    title: 'Comunicaciones',
    nav: 'Comunicaciones',
    subtitle: 'Bandeja de salida de recordatorios al cliente: inspección lista, citas, servicio por vencer y seguimiento de aprobación.',
    kpi: {
      pending: 'Pendientes',
      simulatedToday: 'Simulados hoy',
    },
    filters: {
      kind: 'Tipo',
      status: 'Estado',
      allKinds: 'Todos los tipos',
      allStatuses: 'Todos los estados',
    },
    cols: {
      kind: 'Tipo',
      recipient: 'Destinatario',
      status: 'Estado',
      createdAt: 'Creado',
      actions: 'Acciones',
    },
    kinds: {
      dvi_ready: 'Inspección lista',
      appointment: 'Cita',
      service_due: 'Servicio por vencer',
      approval_followup: 'Seguimiento de aprobación',
    },
    statuses: {
      pending: 'Pendiente',
      simulated: 'Simulado',
      sent: 'Enviado',
      failed: 'Falló',
      suppressed: 'Omitido',
    },
    detail: {
      subject: 'Asunto',
      body: 'Mensaje',
      link: 'Liga',
      channel: 'Canal',
      to: 'Destino',
      sentAt: 'Enviado',
      error: 'Error',
    },
    scanNow: 'Escanear ahora',
    scanEnqueued: 'encoladas',
    scanFlushed: 'enviadas',
    resend: 'Reenviar',
    empty: 'Sin comunicaciones',
  },
  // Global license banner (Task 11) — surfaces /api/me user.license so users
  // see *why* writes are disabled instead of hitting a silent 403. Distinct
  // from admin.licenseGrace/licenseExpired above (SeatBanner, admin-only
  // Entitlement copy scoped to "creating users"); these are the all-routes,
  // all-write-actions banner copy.
  licenseBanner: {
    grace: 'Licencia en periodo de gracia. Renueva pronto para no perder la escritura.',
    expired: 'Licencia vencida. La escritura está deshabilitada hasta renovar.',
    cannotValidate: 'No se puede validar la licencia. Se permite la lectura; la escritura está deshabilitada.',
    misconfigured: 'Licencia mal configurada. Contacta al proveedor.',
    clockSkew: 'No se puede validar la licencia; revisa la fecha y hora del sistema.',
  },
  // Auditoría de escrituras — owner-only combined view over every
  // per-feature write-audit store (/admin/write-audit).
  writeAudit: {
    title: 'Auditoría de escrituras',
    subtitle: 'Todas las acciones de escritura registradas por paceBI: quién, qué, cuándo y resultado.',
    allFeatures: 'Todos los módulos',
    refresh: 'Actualizar',
    downloadCsv: 'Descargar CSV',
    readErrors: 'No se pudieron leer',
    loading: 'Cargando…',
    empty: 'Sin escrituras registradas',
    colAt: 'Fecha',
    colFeature: 'Módulo',
    colUser: 'Usuario',
    colAction: 'Acción',
    colResult: 'Resultado',
    colDetail: 'Detalle',
  },
} as const;
